// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Card, CardContent, Button, Input, Tabs, TabsList, TabsTrigger, TabsContent, Badge } from '../../components/ui';
import RealBarcode from '../../components/common/Barcode';
import {
  IconAdjustmentsHorizontal,
  IconFilter,
  IconPlus,
  IconSearch,
  IconX,
  IconFileText as FileText,
  IconPhoto as ImageIcon,
  IconLayout as Layout,
  IconTypography as Type,
  IconTable as TableIcon,
  IconQrcode as QrCode,
  IconBarcode as BarcodeIcon,
  IconSignature as Signature,
  IconSettings as Settings,
  IconPlus as Plus,
  IconTrash as Trash2,
  IconCopy as Copy,
  IconDownload as Download,
  IconUpload as Upload,
  IconEye as Eye,
  IconPrinter as Printer,
  IconMail as Mail,
  IconShare2 as Share2,
  IconCheck as Check,
  IconChevronRight as ChevronRight,
  IconLanguage as Languages,
  IconChevronDown as ChevronDown,
  IconStack as Layers,
  IconHistory as History,
  IconDeviceFloppy as Save,
  IconAlertCircle as AlertCircle,
  IconFileSpreadsheet as FileSpreadsheet,
  IconZoomIn as ZoomIn,
  IconZoomOut as ZoomOut,
  IconMaximize as Maximize2,
  IconSparkles as Sparkles,
  IconAdjustments as Sliders,
  IconGlobe as Globe,
  IconCalendar as Calendar,
  IconArrowsRightLeft as ArrowRightLeft,
  IconFileCheck as FileCheck,
  IconArrowLeft as ArrowLeft
} from '@tabler/icons-react';
import NewSelectInput from '../../components/NewSelectInput';
import { fetch3, fetch4, fetch5 } from '../../commonApis/commonApis';


const INITIAL_VARIABLES: Record<string, Array<{ key: string; label: string; value?: string }>> = {
  Merchant: [],
  Staff: [],
  Shipment: [],
  Invoice: []
};

const BRAND_LOGOS = [
  { id: 'logo-apex', name: 'TrackTech (Default)', url: '/img/logo-tracktech.svg', entity: 'TrackTech' },
  { id: 'logo-apex-emea', name: 'TrackTech (Dark)', url: '/img/logo-tracktech-black.svg', entity: 'TrackTech' },
  { id: 'logo-white', name: 'TrackTech Header', url: '/img/logo-header.png', entity: 'TrackTech' }
];

const PRESET_4X6_ELEMENTS = [
  { id: 'c46_1', type: 'branding', content: 'logo-apex', x: 20, y: 20, width: 160, height: 50, language: 'bilingual' },
  { id: 'c46_2', type: 'barcode', content: 'tracking_number', x: 220, y: 20, width: 240, height: 50, language: 'english' },
  { id: 'c46_3', type: 'text', content: 'ROUTE CODE / المسار:', x: 20, y: 80, width: 140, height: 15, fontSize: 10, fontWeight: 'bold', color: '#64748B', language: 'bilingual' },
  { id: 'c46_4', type: 'variable', content: 'route_code', x: 20, y: 98, width: 140, height: 25, fontSize: 16, fontWeight: 'bold', color: '#0F172A', language: 'english' },
  { id: 'c46_5', type: 'text', content: 'AREA NAME / المنطقة:', x: 180, y: 80, width: 280, height: 15, fontSize: 10, fontWeight: 'bold', color: '#64748B', language: 'bilingual' },
  { id: 'c46_6', type: 'variable', content: 'area_name', x: 180, y: 98, width: 280, height: 25, fontSize: 15, fontWeight: 'bold', color: '#B38A00', language: 'bilingual' },
  { id: 'c46_7', type: 'text', content: 'SENDER DETAILS / بيانات المرسل:', x: 20, y: 135, width: 440, height: 18, fontSize: 11, fontWeight: 'bold', color: '#334155', language: 'bilingual' },
  { id: 'c46_8', type: 'variable', content: 'merchant_name', x: 20, y: 158, width: 440, height: 22, fontSize: 14, fontWeight: 'bold', color: '#0F172A', language: 'bilingual' },
  { id: 'c46_9', type: 'variable', content: 'origin_city', x: 20, y: 182, width: 440, height: 20, fontSize: 11, color: '#475569', language: 'bilingual' },
  { id: 'c46_10', type: 'variable', content: 'merchant_phone', x: 20, y: 202, width: 220, height: 18, fontSize: 11, fontWeight: 'bold', color: '#0F172A', language: 'english' },
  { id: 'c46_11', type: 'variable', content: 'account_no', x: 260, y: 202, width: 200, height: 18, fontSize: 11, fontWeight: 'bold', color: '#475569', align: 'right', language: 'english' },
  { id: 'c46_12', type: 'text', content: 'SHIP TO (RECIPIENT) / إلى المستلم:', x: 20, y: 230, width: 440, height: 18, fontSize: 11, fontWeight: 'bold', color: '#334155', language: 'bilingual' },
  { id: 'c46_13', type: 'variable', content: 'customer_name', x: 20, y: 252, width: 440, height: 24, fontSize: 16, fontWeight: 'bold', color: '#000000', language: 'bilingual' },
  { id: 'c46_14', type: 'variable', content: 'customer_address', x: 20, y: 278, width: 440, height: 35, fontSize: 12, color: '#1E293B', language: 'bilingual' },
  { id: 'c46_15', type: 'variable', content: 'customer_phone', x: 20, y: 318, width: 240, height: 22, fontSize: 14, fontWeight: 'bold', color: '#0F172A', language: 'english' },
  { id: 'c46_16', type: 'variable', content: 'dest_city', x: 280, y: 318, width: 180, height: 22, fontSize: 14, fontWeight: 'bold', color: '#B38A00', align: 'right', language: 'bilingual' },
  { id: 'c46_17', type: 'qrcode', content: 'awb_number', x: 20, y: 360, width: 110, height: 110, language: 'english' },
  { id: 'c46_18', type: 'text', content: 'AWB NUMBER / رقم البوليصة:', x: 150, y: 365, width: 160, height: 16, fontSize: 10, fontWeight: 'bold', color: '#64748B', language: 'bilingual' },
  { id: 'c46_19', type: 'variable', content: 'awb_number', x: 150, y: 383, width: 160, height: 20, fontSize: 13, fontWeight: 'bold', color: '#0F172A', language: 'english' },
  { id: 'c46_20', type: 'text', content: 'WEIGHT & PIECES / الوزن والقطع:', x: 320, y: 365, width: 140, height: 16, fontSize: 10, fontWeight: 'bold', color: '#64748B', align: 'right', language: 'bilingual' },
  { id: 'c46_21', type: 'variable', content: 'pieces', x: 320, y: 383, width: 140, height: 20, fontSize: 13, fontWeight: 'bold', color: '#0F172A', align: 'right', language: 'english' },
  { id: 'c46_22', type: 'text', content: 'SERVICE TYPE / نوع الخدمة:', x: 150, y: 415, width: 160, height: 16, fontSize: 10, fontWeight: 'bold', color: '#64748B', language: 'bilingual' },
  { id: 'c46_23', type: 'variable', content: 'service_type', x: 150, y: 433, width: 310, height: 22, fontSize: 13, fontWeight: 'bold', color: '#10B981', language: 'bilingual' },
  { id: 'c46_24', type: 'text', content: 'COD AMOUNT / مبلغ الدفع عند الاستلام:', x: 20, y: 500, width: 250, height: 20, fontSize: 12, fontWeight: 'bold', color: '#64748B', language: 'bilingual' },
  { id: 'c46_25', type: 'variable', content: 'cod_amount', x: 280, y: 495, width: 180, height: 35, fontSize: 22, fontWeight: 'bold', color: '#DC2626', align: 'right', language: 'english' },
  { id: 'c46_26', type: 'text', content: 'PAYMENT STATUS / حالة الدفع: CASH ON DELIVERY / الدفع عند الاستلام', x: 20, y: 535, width: 440, height: 18, fontSize: 11, fontWeight: 'bold', color: '#334155', language: 'bilingual' },
  { id: 'c46_27', type: 'text', content: 'COURIER DISPATCH / بيانات المندوب:', x: 20, y: 580, width: 220, height: 18, fontSize: 11, fontWeight: 'bold', color: '#334155', language: 'bilingual' },
  { id: 'c46_28', type: 'variable', content: 'driver_name', x: 20, y: 602, width: 220, height: 20, fontSize: 12, color: '#1E293B', language: 'bilingual' },
  { id: 'c46_29', type: 'variable', content: 'driver_phone', x: 20, y: 624, width: 220, height: 20, fontSize: 12, color: '#475569', language: 'english' },
  { id: 'c46_30', type: 'variable', content: 'driver_vehicle_no', x: 20, y: 646, width: 220, height: 20, fontSize: 12, fontWeight: 'bold', color: '#0F172A', language: 'english' },
  { id: 'c46_31', type: 'text', content: 'RECIPIENT SIGNATURE / توقيع المستلم:', x: 260, y: 580, width: 200, height: 18, fontSize: 11, fontWeight: 'bold', color: '#334155', align: 'right', language: 'bilingual' },
  { id: 'c46_32', type: 'signature', content: 'customer_sign', x: 260, y: 605, width: 200, height: 65, language: 'bilingual' }
];

const INITIAL_TEMPLATES = [
  { id: 't-1', name: 'Standard Shipment Invoice', type: 'Shipment Invoice', version: 'v2.4', status: 'Published', language: 'bilingual', lastUpdated: '2026-05-12', pageSize: 'A4' },
  { id: 't-2', name: 'Express Shipping Label (Thermal)', type: 'Shipping Label', version: 'v1.1', status: 'Published', language: 'english', lastUpdated: '2026-06-22', pageSize: 'Thermal' },
  { id: 't-3', name: 'Bilingual Delivery Note', type: 'Delivery Note', version: 'v3.0-Draft', status: 'Draft', language: 'bilingual', lastUpdated: '2026-07-02', pageSize: 'A4' },
  { id: 't-4', name: 'Logistics 4x6 Shipping Tag', type: 'Shipping Label', version: 'v1.0', status: 'Published', language: 'english', lastUpdated: '2026-07-04', pageSize: '4x6', elements: PRESET_4X6_ELEMENTS },
  { id: 't-5', name: 'Client 4x6 Waybill (Default) / بوليصة شحن للعملاء (4x6)', type: 'Shipping Label', version: 'v1.0', status: 'Published', language: 'bilingual', lastUpdated: '2026-07-07', pageSize: '4x6', isDefault: true, elements: PRESET_4X6_ELEMENTS }
];

const PRESET_ELEMENTS = [
  { id: 'el-1', type: 'branding', content: 'logo-apex', x: 40, y: 30, width: 200, height: 60, language: 'bilingual' },
  { id: 'el-2', type: 'text', content: 'INVOICE / فاتورة', x: 500, y: 35, width: 250, height: 40, fontSize: 24, fontWeight: 'bold', color: '#1e293b', align: 'right', language: 'bilingual' },
  { id: 'el-3', type: 'variable', category: 'Invoice', key: 'invoice_no', content: 'INV-2026-0482', prefix: 'Invoice No: ', prefixAr: 'رقم الفاتورة: ', x: 500, y: 80, width: 250, height: 30, fontSize: 13, fontWeight: 'bold', color: '#475569', align: 'right', language: 'bilingual' },
  { id: 'el-4', type: 'variable', category: 'Company', key: 'comp_name', content: 'Apex Global Logistics', x: 40, y: 110, width: 300, height: 25, fontSize: 14, fontWeight: 'bold', color: '#0f172a', align: 'left', language: 'english' },
  { id: 'el-5', type: 'variable', category: 'Company', key: 'comp_address', content: '100 Wall Street, NY', x: 40, y: 135, width: 300, height: 40, fontSize: 11, fontWeight: 'normal', color: '#64748b', align: 'left', language: 'english' },
  { id: 'el-6', type: 'text', content: 'BILLED TO / فاتورة إلى:', x: 40, y: 200, width: 320, height: 25, fontSize: 12, fontWeight: 'bold', color: '#1e293b', align: 'left', language: 'bilingual' },
  { id: 'el-7', type: 'variable', category: 'Customer', key: 'cust_name', content: 'Al-Futtaim Logistics', x: 40, y: 225, width: 320, height: 25, fontSize: 13, fontWeight: 'bold', color: '#8A6D00', align: 'left', language: 'english' },
  { id: 'el-8', type: 'variable', category: 'Customer', key: 'cust_address', content: 'Dubai Festival City', x: 40, y: 250, width: 320, height: 50, fontSize: 11, fontWeight: 'normal', color: '#475569', align: 'left', language: 'english' },
  {
    id: 'el-9', type: 'table', x: 40, y: 330, width: 710, height: 200, language: 'bilingual', tableData: [
      { id: 'r1', descEn: 'Express Courier Shipment', descAr: 'شحنة البريد السريع', code: 'EXP-SH', qty: '1', rate: '750.00', total: '750.00' },
      { id: 'r2', descEn: 'Customs Clearance Handling', descAr: 'تخليص جمركي معالجة', code: 'CUST-CLR', qty: '1', rate: '150.00', total: '150.00' },
      { id: 'r3', descEn: 'Fuel Surcharge (10%)', descAr: 'رسوم إضافية للوقود', code: 'FUEL-10', qty: '1', rate: '90.00', total: '90.00' }
    ]
  },
  { id: 'el-10', type: 'barcode', barcodeType: 'CODE128', content: 'SH-99281-X', x: 40, y: 560, width: 220, height: 75, language: 'english' },
  { id: 'el-11', type: 'signature', content: 'Authorized Signature', x: 500, y: 560, width: 250, height: 85, language: 'bilingual' }
];

const SYSTEM_FIELDS_BY_CATEGORY: Record<string, Array<{ key: string; label: string; defaultValue: string }>> = {
  Merchant: [
    { key: 'name', label: 'Merchant Name (\u0627\u0633\u0645 \u0627\u0644\u062a\u0627\u062c\u0631)', defaultValue: 'Apex Global Logistics / \u0623\u0628\u0646\u0643\u0633 \u0644\u0644\u062e\u062f\u0645\u0627\u062a \u0627\u0644\u0644\u0648\u062c\u0633\u062a\u064a\u0629' },
    { key: 'mobileNo', label: 'Merchant Phone (\u0647\u0627\u062a\u0641 \u0627\u0644\u062a\u0627\u062c\u0631)', defaultValue: '+966 11 234 5678' },
    { key: 'email', label: 'Merchant Email (\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u0644\u0644\u062a\u0627\u062c\u0631)', defaultValue: 'merchant@apex-logistics.com' },
    { key: 'location', label: 'Merchant Address (\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062a\u0627\u062c\u0631)', defaultValue: 'Olaya District, Riyadh, KSA' },
    { key: 'shortAddress', label: 'Merchant Short Address (\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u062e\u062a\u0635\u0631)', defaultValue: 'RCWC3512' },
    { key: 'accountNo', label: 'Account Number (\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628)', defaultValue: 'ACCT-882910' },
    { key: 'vatNumber', label: 'VAT Number (\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0636\u0631\u064a\u0628\u064a)', defaultValue: '300123456700003' },
    { key: 'crNumber', label: 'CR Number (\u0627\u0644\u0633\u062c\u0644 \u0627\u0644\u062a\u062c\u0627\u0631\u064a)', defaultValue: '1010987654' },
    { key: 'zipCode', label: 'Zip Code (\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a)', defaultValue: '12626' },
    { key: 'contactPerson', label: 'Contact Person (\u0627\u0644\u0634\u062e\u0635 \u0627\u0644\u0645\u0633\u062a\u0644\u0645)', defaultValue: 'AB de Villiers' }
  ],
  Staff: [
    { key: 'name', label: 'Staff Name (\u0627\u0633\u0645 \u0627\u0644\u0645\u0648\u0638\u0641)', defaultValue: 'Khalid Al-Ghamdi / \u062e\u0627\u0644\u062f \u0627\u0644\u063a\u0627\u0645\u062f\u064a' },
    { key: 'phone', label: 'Staff Phone (\u0647\u0627\u062a\u0641 \u0627\u0644\u0645\u0648\u0638\u0641)', defaultValue: '+966 50 123 4567' },
    { key: 'email', label: 'Staff Email (البريد الإلكتروني للموظف)', defaultValue: 'driver.khalid@apex-logistics.com' },
    { key: 'vehicleNumber', label: 'Vehicle Number (رقم السيارة)', defaultValue: 'KSA 4821 BLC' },
    { key: 'iqamaNo', label: 'National ID / Iqama (رقم الهوية / الإقامة)', defaultValue: '2309876543' },
    { key: 'address', label: 'Staff Address (عنوان الموظف)', defaultValue: 'Al Malaz, Riyadh, SA' },
  
  ],
  Shipment: [
    { key: 'referenceNumber', label: 'Tracking Barcode Number (رقم التتبع)', defaultValue: 'TRK-99281-KSA' },
    { key: 'awbNumber', label: 'Air Waybill Number (رقم البوليصة / AWB)', defaultValue: 'AWB-2026-99281' },
    { key: 'orderName', label: 'Order Name (اسم الطلب)', defaultValue: 'ORD-9921A' },
    { key: 'routeCode', label: 'Route Code (رمز المسار)', defaultValue: 'RUH-NORTH-04' },
    { key: 'areaName', label: 'Area Name (اسم المنطقة)', defaultValue: 'Al Olaya District / حي العليا' },
    { key: 'customerName', label: 'Recipient Name (اسم المستلم)', defaultValue: 'Abdullah Al-Rajhi / عبدالله الراجحي' },
    { key: 'customerAddress', label: 'Recipient Address (عنوان المستلم)', defaultValue: 'King Fahd Road, Bldg 45, Apt 12' },
    { key: 'customerPhone', label: 'Recipient Phone (هاتف المستلم)', defaultValue: '+966 55 987 6543' },
    { key: 'destCity', label: 'Destination City (مدينة الوصول)', defaultValue: 'Riyadh / الرياض' },
    { key: 'pieces', label: 'Weight & Pieces (الوزن والقطع)', defaultValue: '2.5 KG / 1 PCS' },
    { key: 'serviceType', label: 'Service Type (نوع الخدمة)', defaultValue: 'Express Delivery / التوصيل السريع' },
    { key: 'codAmount', label: 'COD Amount (مبلغ التحصيل عند الاستلام)', defaultValue: 'SAR 350.00' },
   
  ],
  Invoice: [
    { key: 'invoiceNo', label: 'Invoice Number (رقم الفاتورة)', defaultValue: 'INV-2026-0482' },
    { key: 'invoiceDate', label: 'Invoice Date (تاريخ الفاتورة)', defaultValue: '2026-07-07' },
    { key: 'taxAmount', label: 'VAT Amount (قيمة الضريبة 15%)', defaultValue: 'SAR 52.50' },
    { key: 'totalAmount', label: 'Total Amount (المبلغ الإجمالي)', defaultValue: 'SAR 402.50' },
    { key: 'paymentMethod', label: 'Payment Method (طريقة الدفع)', defaultValue: 'Credit Card' }
  ]
};

export default function DocumentDesigner() {
  // Navigation & States
  const [activeTab, setActiveTab] = useState('templates'); // 'templates' | 'designer' | 'branding' | 'variables'
  const [templates, setTemplates] = useState(INITIAL_TEMPLATES);
  const [selectedTemplate, setSelectedTemplate] = useState(INITIAL_TEMPLATES[0]);

  const [showSearch, setShowSearch] = useState(false);
  const [searchFor, setSearchFor] = useState(''); // template search query

  // Custom Variables list & Dynamic filtering state
  const [variables, setVariables] = useState(INITIAL_VARIABLES);
  const [categories, setCategories] = useState([
    { id: 'cat-1', name: 'Merchant', isDefault: true },
    { id: 'cat-2', name: 'Staff', isDefault: true },
    { id: 'cat-3', name: 'Shipment', isDefault: true },
    { id: 'cat-4', name: 'Invoice', isDefault: true }
  ]);
  const [newVarCategory, setNewVarCategory] = useState('Merchant');
  const [newVarName, setNewVarName] = useState('');
  const [newVarKey, setNewVarKey] = useState('');
  const [newVarVal, setNewVarVal] = useState('');
  const [varSearchQuery, setVarSearchQuery] = useState('');
  const [selectedVarCategoryFilter, setSelectedVarCategoryFilter] = useState('all');
  const [isCustomCategory, setIsCustomCategory] = useState(false);
  const [customCategoryName, setCustomCategoryName] = useState('');
  const [copiedVarKey, setCopiedVarKey] = useState(null);
  const [tokenSearchQuery, setTokenSearchQuery] = useState('');

  // Logo / Branding State
  const [logos, setLogos] = useState(BRAND_LOGOS);
  const [newLogoName, setNewLogoName] = useState('');
  const [newLogoUrl, setNewLogoUrl] = useState('');
  const [newLogoEntity, setNewLogoEntity] = useState('');

  // Designer Canvas settings
  const [canvasWidth, setCanvasWidth] = useState(790); // default A4 representation width in px
  const [canvasHeight, setCanvasHeight] = useState(750); // height inside scrollable area
  const [pageSize, setPageSize] = useState('A4'); // A4, Letter, Thermal
  const [docLanguage, setDocLanguage] = useState('bilingual'); // english, arabic, bilingual
  const [zoom, setZoom] = useState(100);

  // Element elements currently on canvas
  const [canvasElements, setCanvasElements] = useState(PRESET_ELEMENTS);
  const [selectedElementId, setSelectedElementId] = useState(null);

  // Template Form Fields
  const [templateName, setTemplateName] = useState('Standard Shipment Invoice');
  const [templateType, setTemplateType] = useState('Shipment Invoice');
  const [templateVersion, setTemplateVersion] = useState('v2.4');
  const [templateStatus, setTemplateStatus] = useState('Published');

  // Preview / Output Modal Simulator
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewValues, setPreviewValues] = useState({});
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [showNotification, setShowNotification] = useState(null);

  // Helper trigger notifications
  const triggerNotification = (message, type = 'success') => {
    setShowNotification({ message, type });
    setTimeout(() => setShowNotification(null), 4000);
  };

  const fetchCategoriesAndVariables = async () => {
    try {
      const catsRes = await fetch3('/api/document-designer/categories', 'get');
      if (catsRes?.success && Array.isArray(catsRes.data) && catsRes.data.length > 0) {
        setCategories(catsRes.data);
      }
    } catch (e) {
      console.warn('Using fallback categories:', e);
    }
    try {
      const varsRes = await fetch3('/api/document-designer/variables', 'get');
      if (varsRes?.success && varsRes.data && typeof varsRes.data === 'object' && Object.keys(varsRes.data).length > 0) {
        setVariables(varsRes.data);
      }
    } catch (e) {
      console.warn('Using fallback variables:', e);
    }
  };

  const handleUpdateCategory = async (idOrName, newName) => {
    try {
      await fetch5(`/api/document-designer/categories/${encodeURIComponent(idOrName)}`, 'put', { name: newName });
      triggerNotification(`Category successfully renamed to "${newName}".`);
      if (selectedVarCategoryFilter === idOrName) {
        setSelectedVarCategoryFilter(newName);
      }
      await fetchCategoriesAndVariables();
    } catch (err) {
      console.error('Error updating category:', err);
      triggerNotification('Failed to rename category. Default system categories cannot be modified.', 'error');
    }
  };

  const handleDeleteCategory = async (idOrName) => {
    try {
      await fetch5(`/api/document-designer/categories/${encodeURIComponent(idOrName)}`, 'delete');
      triggerNotification(`Category "${idOrName}" and its variables were deleted.`);
      if (selectedVarCategoryFilter === idOrName) {
        setSelectedVarCategoryFilter('all');
      }
      await fetchCategoriesAndVariables();
    } catch (err) {
      console.error('Error deleting category:', err);
      triggerNotification('Failed to delete category. Default system categories cannot be deleted.', 'error');
    }
  };

  // Fetch initial dynamic data from backend API with fallback to local constants
  useEffect(() => {
    const fetchDynamicData = async () => {
      try {
        const templatesRes = await fetch3('/api/document-designer/templates', 'get');
        if (templatesRes?.success && Array.isArray(templatesRes.data) && templatesRes.data.length > 0) {
          setTemplates(templatesRes.data);
          setSelectedTemplate(templatesRes.data[0]);
        }
      } catch (e) {
        console.warn('Using fallback templates:', e);
      }
      try {
        const logosRes = await fetch3('/api/document-designer/logos', 'get');
        if (logosRes?.success && Array.isArray(logosRes.data) && logosRes.data.length > 0) {
          setLogos(logosRes.data);
        }
      } catch (e) {
        console.warn('Using fallback logos:', e);
      }
      await fetchCategoriesAndVariables();
    };
    fetchDynamicData();
  }, []);

  // Switch canvas dimensions and auto-align existing elements based on format
  useEffect(() => {
    let newW = 790;
    let newH = 750;
    if (pageSize === 'Thermal') {
      newW = 400;
      newH = 800;
    } else if (pageSize === '4x6') {
      newW = 480;
      newH = 720;
    } else if (pageSize === 'Letter') {
      newW = 815;
      newH = 720;
    }
    setCanvasWidth(newW);
    setCanvasHeight(newH);

    // Automatically align and constrain element widths & X-positions so nothing overflows or drifts ("idhar udhar")
    setCanvasElements(prev => prev.map(el => {
      const margin = pageSize === 'Thermal' ? 15 : pageSize === '4x6' ? 20 : 40;
      const maxUsableWidth = newW - (margin * 2);
      let w = el.width;
      let x = el.x;

      if (el.type === 'table' || (w && w > maxUsableWidth - 20)) {
        w = maxUsableWidth;
        x = margin;
      } else {
        if (w && x + w > newW - margin) {
          x = Math.max(margin, newW - w - margin);
        } else if (x > newW - margin - 50) {
          x = Math.max(margin, newW - (w || 100) - margin);
        }
      }
      return { ...el, width: w, x };
    }));
  }, [pageSize]);

  // Automatically load appropriate elements when switching templates
  useEffect(() => {
    if (!selectedTemplate) return;
    const tSize = selectedTemplate.pageSize || (selectedTemplate.name?.includes('Thermal') ? 'Thermal' : selectedTemplate.name?.includes('4x6') ? '4x6' : 'A4');
    if (selectedTemplate.elements && Array.isArray(selectedTemplate.elements) && selectedTemplate.elements.length > 0) {
      setCanvasElements(selectedTemplate.elements);
    } else if (selectedTemplate.layoutConfig?.elements && Array.isArray(selectedTemplate.layoutConfig.elements) && selectedTemplate.layoutConfig.elements.length > 0) {
      setCanvasElements(selectedTemplate.layoutConfig.elements);
    } else if (tSize === '4x6') {
      setCanvasElements(PRESET_4X6_ELEMENTS);
    } else {
      setCanvasElements(PRESET_ELEMENTS);
    }
  }, [selectedTemplate]);

  // Handle Drag / Move of elements on the canvas (Simulated Designer Interactivity)
  const handleMoveElement = (id, direction, step = 15) => {
    if (selectedTemplate?.isDefault) return;
    setCanvasElements(prev => prev.map(el => {
      if (el.id !== id) return el;
      let newX = el.x;
      let newY = el.y;
      if (direction === 'up') newY = Math.max(0, el.y - step);
      if (direction === 'down') newY = Math.min(canvasHeight - 50, el.y + step);
      if (direction === 'left') newX = Math.max(0, el.x - step);
      if (direction === 'right') newX = Math.min(canvasWidth - 100, el.x + step);
      return { ...el, x: newX, y: newY };
    }));
  };

  // Add standard elements to canvas
  const addElementToCanvas = (type, metadata = {}) => {
    if (selectedTemplate?.isDefault) {
      triggerNotification('Default templates are read-only. Duplicate the template to customize.', 'warning');
      return;
    }
    const defaultPositions = {
      text: { content: 'New Static Text / نص جديد', width: 200, height: 40, fontSize: 13, fontWeight: 'normal', color: '#000000', align: 'left', language: 'english' },
      variable: { ...metadata, width: 180, height: 35, fontSize: 12, fontWeight: 'bold', color: '#B38A00', align: 'left', language: 'bilingual' },
      branding: { content: logos[0]?.id || 'logo-apex', width: 180, height: 60, language: 'bilingual' },
      barcode: { content: 'BARCODE-XYZ', barcodeType: 'CODE128', width: 180, height: 60, language: 'english' },
      signature: { content: 'Authorized Signatory', width: 200, height: 80, language: 'bilingual' },
      table: {
        width: Math.min(canvasWidth - 80, 710), height: 180, language: 'bilingual', tableData: [
          { id: 'tr1', descEn: 'Item Description', descAr: 'وصف البند', code: 'CD-1', qty: '1', rate: '100.00', total: '100.00' }
        ]
      }
    };

    const newEl = {
      id: `el-${Date.now()}`,
      type,
      x: Math.min(40, Math.max(10, Math.round((canvasWidth - (defaultPositions[type]?.width || 180)) / 2))),
      y: 150 + (canvasElements.length * 15) % 300,
      ...defaultPositions[type],
      ...metadata
    };

    setCanvasElements(prev => [...prev, newEl]);
    setSelectedElementId(newEl.id);
    triggerNotification(`Added new ${type} element to canvas.`);
  };

  // Handle custom variable addition
  const handleAddVariable = async (e) => {
    e.preventDefault();
    if (!newVarName || !newVarKey) {
      triggerNotification('Please provide a variable name and a system key.', 'error');
      return;
    }
    const cleanKey = newVarKey.toLowerCase().replace(/[^a-z0-9_]/g, '_');
    const targetCategory = isCustomCategory ? (customCategoryName.trim() || 'Custom') : newVarCategory;

    try {
      if (isCustomCategory && customCategoryName.trim()) {
        try {
          await fetch4('/api/document-designer/categories', { name: targetCategory, description: 'Custom variable category' });
        } catch (catErr) {
          console.warn('Category might already exist or failed to create:', catErr);
        }
      }
      await fetch4('/api/document-designer/variables', {
        key: cleanKey,
        label: newVarName,
        value: newVarVal || 'Dynamic Value',
        category: targetCategory,
        isCustom: true
      });
      await fetchCategoriesAndVariables();
    } catch (err) {
      console.warn('API error, falling back to local variable add:', err);
      const newVarObj = { key: cleanKey, label: newVarName, value: newVarVal || 'Dynamic Value' };
      setVariables(prev => ({
        ...prev,
        [targetCategory]: [...(prev[targetCategory] || []), newVarObj]
      }));
    }

    setNewVarName('');
    setNewVarKey('');
    setNewVarVal('');
    if (isCustomCategory) {
      setCustomCategoryName('');
      setIsCustomCategory(false);
      setNewVarCategory(targetCategory);
    }
    triggerNotification(`Variable {{${cleanKey}}} successfully added to ${targetCategory}.`);
  };

  // Handle copying variable token to clipboard
  const handleCopyToken = (key) => {
    const token = `{{${key}}}`;
    navigator.clipboard.writeText(token);
    setCopiedVarKey(key);
    triggerNotification(`Copied dynamic token ${token} to clipboard!`);
    setTimeout(() => setCopiedVarKey(null), 2000);
  };

  // Handle new Logo Brand uploading simulated
  const handleAddLogo = async (e) => {
    e.preventDefault();
    if (!newLogoName || !newLogoUrl) {
      triggerNotification('Please fill in the logo name and hosted URL.', 'error');
      return;
    }
    const newLogo = {
      id: `logo-${Date.now()}`,
      name: newLogoName,
      url: newLogoUrl,
      entity: newLogoEntity || 'General Entity'
    };
    try {
      await fetch4('/api/document-designer/logos', {
        name: newLogoName,
        url: newLogoUrl,
        entity: newLogoEntity || 'General Entity'
      });
      const logosRes = await fetch3('/api/document-designer/logos', 'get');
      if (logosRes?.success && Array.isArray(logosRes.data)) {
        setLogos(logosRes.data);
      } else {
        setLogos(prev => [...prev, newLogo]);
      }
    } catch (err) {
      console.warn('API error, saving logo locally:', err);
      setLogos(prev => [...prev, newLogo]);
    }
    setNewLogoName('');
    setNewLogoUrl('');
    setNewLogoEntity('');
    triggerNotification('New company/entity branding logo registered.');
  };

  // Duplication of Template — copies ALL fields including elements, so the clone is fully editable
  const handleDuplicateTemplate = async (template) => {
    const copyName = `${template.name} (Copy)`;
    try {
      // POST creates the new template with every field copied from the original
      await fetch4('/api/document-designer/templates', {
        name: copyName,
        type: template.type,
        dimensions: template.dimensions || { width: 790, height: 750 },
        orientation: template.orientation || 'portrait',
        margin: template.margin ?? 40,
        status: 'Draft',
        language: template.language || 'bilingual',
        // Copy the full canvas elements array — this is what makes the duplicate useful
        elements: Array.isArray(template.elements) ? template.elements : [],
        usedVariables: Array.isArray(template.usedVariables) ? template.usedVariables : [],
        isDefault: false,  // duplicates are always custom / editable
      });
      // Re-fetch the updated list from server
      const listRes = await fetch3('/api/document-designer/templates', 'get');
      if (listRes?.success && Array.isArray(listRes.data)) {
        setTemplates(listRes.data);
      }
      triggerNotification(`Template duplicated as: "${copyName}"`);
    } catch (err: any) {
      console.error('Duplicate error:', err);
      triggerNotification(err?.message || 'Failed to duplicate template.', 'error');
    }
  };

  // Find selected canvas element details
  const selectedElement = useMemo(() => {
    return canvasElements.find(el => el.id === selectedElementId);
  }, [canvasElements, selectedElementId]);

  // Update properties of the current element
  const updateSelectedElement = (property, value) => {
    if (selectedTemplate?.isDefault) return;
    setCanvasElements(prev => prev.map(el => {
      if (el.id !== selectedElementId) return el;
      return { ...el, [property]: value };
    }));
  };


  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  return (
    <div className="w-full pb-4 text-slate-800 font-sans">
      {/* Top Warning Banner / Realtime Status */}
      {showNotification && (
        <div className={`fixed top-4 right-4 z-50 p-4 rounded-xl shadow-2xl flex items-center gap-3 border ${showNotification.type === 'error' ? 'bg-rose-50 border-rose-200 text-rose-800' : 'bg-emerald-50 border-emerald-200 text-emerald-800'
          } transition-all duration-300 transform translate-y-0`}>
          <Sparkles className="h-5 w-5 animate-bounce" />
          <p className="font-semibold text-sm">{showNotification.message}</p>
        </div>
      )}

      {/* Main Module Layout Container */}
      <div className="flex flex-col overflow-hidden rounded-2xl border border-white/70 bg-white/30 shadow-sm">

        {/* Module Header */}
        {/* <header className=" text-[#212121] px-5 py-3 flex flex-col 2xl:flex-row 2xl:items-center justify-between gap-3 shadow-lg sshrink-0">
          <div className="flex items-center gap-3 min-w-0">
            <div className="bg-[#FBD037] p-2 rounded-lg text-slate-950">
              <Layout className="h-6 w-6" />
            </div>
            <div className="min-w-0">
              <h1 className="text-base lg:text-lg font-bold tracking-tight truncate">Enterprise Template & Brand Management</h1>
              <p className="text-xs text-slate-400 truncate">Manage multi-language transactional templates, dynamic variables, and custom designs</p>
            </div>
          </div>
          <div className="flex w-full 2xl:w-auto items-center gap-1.5 overflow-x-auto pb-1 2xl:pb-0">
            <Button 
              variant={activeTab === 'templates' ? 'default' : 'ghost'} 
              className={activeTab === 'templates' ? 'bg-[#FBD037] hover:bg-yellow-400 text-slate-950' : 'text-[#212121] hover:bg-slate-800'}
              onClick={() => setActiveTab('templates')}
            >
              <FileSpreadsheet className="mr-2 h-4 w-4" /> Templates
            </Button>
            <Button 
              variant={activeTab === 'designer' ? 'default' : 'ghost'} 
              className={activeTab === 'designer' ? 'bg-[#FBD037] hover:bg-yellow-400 text-slate-950' : 'text-slate-200 hover:bg-slate-800'}
              onClick={() => {
                setActiveTab('designer');
                triggerNotification("Switched to Drag-and-Drop Document Designer Workspace.");
              }}
            >
              <Sliders className="mr-2 h-4 w-4" /> Document Designer
            </Button>
            <Button 
              variant={activeTab === 'branding' ? 'default' : 'ghost'} 
              className={activeTab === 'branding' ? 'bg-[#FBD037] hover:bg-yellow-400 text-slate-950' : 'text-slate-200 hover:bg-slate-800'}
              onClick={() => setActiveTab('branding')}
            >
              <Globe className="mr-2 h-4 w-4" /> Brand & Entity Assets
            </Button>
            <Button 
              variant={activeTab === 'variables' ? 'default' : 'ghost'} 
              className={activeTab === 'variables' ? 'bg-[#FBD037] hover:bg-yellow-400 text-slate-950' : 'text-slate-200 hover:bg-slate-800'}
              onClick={() => setActiveTab('variables')}
            >
              <ArrowRightLeft className="mr-2 h-4 w-4" /> System Variables
            </Button>
          </div>
        </header> */}

        {/* Dashboard Content Workspace */}
        <div className="flex-1 flex min-h-0 overflow-hidden">

          {/* VIEW 1: TEMPLATES REGISTER */}
          {activeTab === 'templates' && (
            <div className="flex-1 overflow-y-auto p-4 lg:p-6 w-full space-y-6">
              {/* <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                  <h2 className="text- font-bold text-slate-900">Document Templates Registry</h2>

                </div>

             


                <Button className="bg-[#FBD037] hover:bg-yellow-400 text-slate-950" onClick={() => {
                  setTemplateName('New Custom Template');
                  setTemplateType('Customs Documents');
                  setTemplateVersion('v1.0-Draft');
                  setTemplateStatus('Draft');
                  setActiveTab('designer');
                }}>
                  <Plus className="mr-2 h-4 w-4" /> Create Custom Document Template
                </Button>
              </div> */}


              {/* Main Template List Table */}
              <Card className="bg-white border-slate-200 shadow-md">
                <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
                  <span className="font-bold text-slate-900 text-base">All Registered Document Formats</span>
                  <div className="flex items-center flex-wrap gap-2.5">

                    <div className="relative flex items-center group">
                      <div
                        onClick={() => {
                          if (!showSearch) {
                            setShowSearch(true);
                          }
                        }}
                        className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-lg bg-white shadow-sm h-8 ${showSearch
                          ? "w-64 px-2 cursor-default"
                          : "w-8 justify-center cursor-pointer hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95"
                          }`}
                      >
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowSearch(!showSearch);
                          }}
                          className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
                        >
                          <IconSearch size={17} stroke={2.5} />
                        </button>
                        {showSearch && (
                          <>
                            <input
                              type="text"
                              value={searchFor}
                              onChange={(e) => setSearchFor(e.target.value)}
                              placeholder={t("Search...")}
                              autoFocus
                              className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none"
                            />
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setSearchFor("");
                                setShowSearch(false);
                              }}
                              className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                              title={t("Clear & Close")}
                            >
                              <IconX size={14} stroke={2.5} />
                            </button>
                          </>
                        )}
                      </div>


                    </div>



                    {/* Filter Sidebar toggle */}
                    <div className="relative group">
                      <button

                        className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer"
                      >
                        <IconAdjustmentsHorizontal size={17} stroke={2} />
                      </button>

                    </div>
                    <div className="relative group">
                      <button

                        className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer"
                      >
                        <IconFilter size={17} stroke={2} />
                      </button>

                    </div>


                    {/* Add Order */}
                    <div className="relative inline-block">
                      <button
                        onClick={async () => {
                          const newT = {
                            id: `t-${Date.now()}`,
                            name: 'New Custom Template',
                            type: 'Customs Documents',
                            dimensions: 'A4',
                            version: 'v1.0-Draft',
                            status: 'Draft',
                            lastUpdated: new Date().toISOString().split('T')[0]
                          };
                          try {
                            const res = await fetch4('/api/document-designer/templates', newT);
                            if (res?.success && res.data) {
                              setTemplates(prev => [res.data, ...prev]);
                              setSelectedTemplate(res.data);
                            } else {
                              setTemplates(prev => [newT, ...prev]);
                              setSelectedTemplate(newT);
                            }
                          } catch (err) {
                            console.warn('API error, creating template locally:', err);
                            setTemplates(prev => [newT, ...prev]);
                            setSelectedTemplate(newT);
                          }
                          setTemplateName('New Custom Template');
                          setTemplateType('Customs Documents');
                          setTemplateVersion('v1.0-Draft');
                          setTemplateStatus('Draft');
                          setActiveTab('designer');
                        }}
                        className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer"
                        title="Add New Template"
                      >
                        <IconPlus size={17} stroke={2.5} />
                      </button>
                    </div>

                    {/* Add Variables Section Button */}
                    <div className="relative inline-block">
                      <button
                        onClick={() => setActiveTab('variables')}
                        className="h-8 px-3 flex items-center gap-1.5 bg-[#FBD037] hover:bg-[#f3c82b] text-slate-950 font-bold text-xs rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer border border-[#e5bc24]"
                        title="Add Token Variables"
                      >
                        <IconPlus size={15} stroke={2.5} />
                        <span>Add Variables</span>
                      </button>
                    </div>
                  </div>
                </div>
                <CardContent className="p-0">
                  <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                      <thead>
                        <tr className="bg-slate-50 border-b border-slate-100 text-slate-600 text-xs uppercase tracking-wider">
                          <th className="py-3 px-6 font-semibold">Template Name</th>
                          <th className="py-3 px-6 font-semibold">Document Category</th>
                          <th className="py-3 px-6 font-semibold">Version</th>
                          <th className="py-3 px-6 font-semibold">Layout Language</th>
                          <th className="py-3 px-6 font-semibold">Status</th>
                          <th className="py-3 px-6 font-semibold">Last Updated</th>
                          <th className="py-3 px-6 font-semibold text-right">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100 text-sm">
                        {templates.map((template) => (
                          <tr key={template.id} className="hover:bg-slate-50/70 transition-colors">
                            <td className="py-4 px-6 font-semibold text-slate-900">
                              <div className="flex items-center gap-2">
                                <FileText className="h-4 w-4 text-amber-600" />
                                {template.name}
                              </div>
                            </td>
                            <td className="py-4 px-6 text-slate-600">{template.type}</td>
                            <td className="py-4 px-6">
                              <Badge variant="secondary" className="bg-slate-100 text-slate-700 whitespace-nowrap">{template.version}</Badge>
                            </td>
                            <td className="py-4 px-6">
                              <div className="flex items-center gap-2 capitalize">
                                <Languages className="h-4 w-4 text-slate-400" />
                                {template.language}
                              </div>
                            </td>
                            <td className="py-4 px-6">
                              <Badge className={
                                template.status === 'Published'
                                  ? 'bg-emerald-100 text-emerald-800 border-none'
                                  : 'bg-amber-100 text-amber-800 border-none'
                              }>
                                {template.status}
                              </Badge>
                            </td>
                            <td className="py-4 px-6 text-slate-500">{template.lastUpdated}</td>
                            <td className="py-4 px-6 text-right">
                              <div className="flex justify-end gap-2">
                                {template.isDefault ? (
                                  <div className="flex items-center gap-2">
                                    <Button
                                      size="sm"
                                      variant="outline"
                                      className="text-slate-600 border-slate-200 hover:bg-slate-50 flex items-center gap-1.5"
                                      onClick={() => {
                                        setSelectedTemplate(template);
                                        setTemplateName(template.name);
                                        setTemplateType(template.type);
                                        setTemplateVersion(template.version || 'v1.0');
                                        setTemplateStatus(template.status || 'Draft');
                                        setDocLanguage(template.language || template.docLanguage || 'bilingual');
                                        const tSize = template.pageSize || (
                                          template.dimensions?.width <= 480 ? '4x6'
                                          : template.name?.includes?.('Thermal') ? 'Thermal'
                                          : 'A4'
                                        );
                                        setPageSize(tSize);
                                        setActiveTab('designer');
                                      }}
                                    >
                                      <Eye className="h-3.5 w-3.5 text-slate-500" /> View Layout
                                    </Button>
                                    <div className="flex items-center gap-1 px-2.5 py-1 rounded-md border border-slate-200 bg-slate-50 text-slate-400 text-[10px] font-bold select-none uppercase tracking-wide" title="Default system template — duplicate it to create your own editable copy">
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                                      Locked
                                    </div>
                                  </div>
                                ) : (
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    className="text-[#7A6100] border-yellow-200 hover:bg-[#FFF8D6]"
                                    onClick={() => {
                                      setSelectedTemplate(template);
                                      setTemplateName(template.name);
                                      setTemplateType(template.type);
                                      setTemplateVersion(template.version || 'v1.0');
                                      setTemplateStatus(template.status || 'Draft');
                                      setDocLanguage(template.language || template.docLanguage || 'bilingual');
                                      const tSize = template.pageSize || (
                                        template.dimensions?.width <= 480 ? '4x6'
                                        : template.name?.includes?.('Thermal') ? 'Thermal'
                                        : 'A4'
                                      );
                                      setPageSize(tSize);
                                      setActiveTab('designer');
                                    }}
                                  >
                                    Edit Layout
                                  </Button>
                                )}
                                <Button
                                  size="icon"
                                  variant="ghost"
                                  title="Duplicate Template"
                                  className="text-slate-600 hover:text-slate-900"
                                  onClick={() => handleDuplicateTemplate(template)}
                                >
                                  <Copy className="h-4 w-4" />
                                </Button>
                                {!template.isDefault && (
                                  <Button
                                    size="icon"
                                    variant="ghost"
                                    className="text-rose-500 hover:text-rose-700 hover:bg-rose-50"
                                    title="Delete template"
                                    onClick={async () => {
                                      try {
                                        await fetch5(`/api/document-designer/templates/${template.id}`, 'delete');
                                      } catch (err) {
                                        console.warn('API error, deleting template locally:', err);
                                      }
                                      setTemplates(prev => prev.filter(t => t.id !== template.id));
                                      triggerNotification(`Template "${template.name}" removed from registry.`, 'error');
                                    }}
                                  >
                                    <Trash2 className="h-4 w-4" />
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardContent>
              </Card>
            </div>
          )}

          {/* VIEW 2: BRANDING MANAGEMENT */}
          {activeTab === 'branding' && (
            <div className="flex-1 overflow-y-auto p-4 lg:p-6 w-full space-y-6">
              <div className="space-y-3">
                <button
                  onClick={() => setActiveTab('templates')}
                  className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-bold text-slate-700 hover:text-slate-950 hover:bg-slate-100 bg-white border border-slate-200 transition-all duration-150 cursor-pointer shadow-sm"
                >
                  <ArrowLeft className="h-4 w-4 text-slate-600" />
                </button>
                <div>
                  <h2 className="text-2xl font-bold text-slate-900">Multi-Entity & Brand Assets</h2>
                  <p className="text-sm text-slate-500">Add dynamic corporate headers and custom entity logos for localized customer agreements</p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                {/* Logo Creator Form */}
                <Card className="bg-white border-slate-200 shadow-md col-span-1">
                  <div className="px-6 py-4 border-b border-slate-100">
                    <span className="font-bold text-slate-900">Register New Entity Brand</span>
                  </div>
                  <CardContent className="p-6">
                    <form onSubmit={handleAddLogo} className="space-y-4">
                      <div>
                        <label className="text-xs font-semibold uppercase text-slate-500">Logo Name / Label</label>
                        <Input
                          placeholder="e.g., Apex Logistics Europe"
                          value={newLogoName}
                          onChange={(e) => setNewLogoName(e.target.value)}
                          className="mt-1"
                        />
                      </div>
                      <div>
                        <label className="text-xs font-semibold uppercase text-slate-500">Upload Image File (Base64)</label>
                        <Input
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.onload = (event) => {
                                if (event.target?.result) {
                                  setNewLogoUrl(event.target.result as string);
                                  triggerNotification('Local logo file loaded successfully.');
                                }
                              };
                              reader.readAsDataURL(file);
                            }
                          }}
                          className="mt-1 text-xs cursor-pointer border-dashed border-2 py-1 flex items-center justify-center"
                        />
                      </div>
                      <div>
                        <label className="text-xs font-semibold uppercase text-slate-500">Or Paste Image URL</label>
                        <Input
                          placeholder="https://placehold.co/180x60/..."
                          value={newLogoUrl}
                          onChange={(e) => setNewLogoUrl(e.target.value)}
                          className="mt-1"
                        />
                      </div>
                      {newLogoUrl && (
                        <div className="mt-2 p-3 border border-slate-200 bg-slate-50 rounded-lg flex flex-col items-center gap-1.5 shadow-inner">
                          <span className="text-[10px] uppercase font-bold text-slate-400">Logo Image Preview</span>
                          <img src={newLogoUrl} className="max-h-12 object-contain" alt="Preview" />
                        </div>
                      )}
                      <div>
                        <label className="text-xs font-semibold uppercase text-slate-500">Target Business Entity</label>
                        <Input
                          placeholder="e.g., Apex EMEA LLC"
                          value={newLogoEntity}
                          onChange={(e) => setNewLogoEntity(e.target.value)}
                          className="mt-1"
                        />
                      </div>
                      <Button type="submit" className="w-full bg-[#FBD037] hover:bg-yellow-400 text-slate-950">
                        <Plus className="mr-2 h-4 w-4" /> Save Brand Asset
                      </Button>
                    </form>
                  </CardContent>
                </Card>

                {/* Display Current Logos */}
                <div className="col-span-2 space-y-4">
                  <h3 className="font-bold text-slate-900 text-lg">Active Corporate Identities</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {logos.map(logo => (
                      <Card key={logo.id} className="bg-white border-slate-200 shadow-sm relative group overflow-hidden">
                        <CardContent className="p-4 flex flex-col justify-between h-full space-y-4">
                          <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 flex justify-center items-center">
                            <img src={logo.url} alt={logo.name} className="max-h-12 object-contain" />
                          </div>
                          <div>
                            <h4 className="font-bold text-slate-900">{logo.name}</h4>
                            <p className="text-xs text-slate-500">{logo.entity}</p>
                          </div>
                          <div className="pt-2 border-t border-slate-100 flex justify-between items-center text-xs">
                            <span className="text-slate-400">ID: {logo.id}</span>
                            <Button
                              size="sm"
                              variant="ghost"
                              className="text-rose-500 hover:text-rose-700 h-8 px-2"
                              onClick={async () => {
                                try {
                                  await fetch5(`/api/document-designer/logos/${logo.id}`, 'delete');
                                } catch (err) {
                                  console.warn('API error, deleting logo locally:', err);
                                }
                                setLogos(prev => prev.filter(l => l.id !== logo.id));
                                triggerNotification('Identity logo deleted.', 'error');
                              }}
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          )}

          {/* VIEW 3: VARIABLE MANAGEMENT */}
          {activeTab === 'variables' && (
            <div className="flex-1 overflow-y-auto p-4 lg:p-6 w-full space-y-6">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="space-y-2">
                  <button
                    onClick={() => setActiveTab('templates')}
                    className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-bold text-slate-700 hover:text-slate-950 hover:bg-slate-100 bg-white border border-slate-200 transition-all duration-150 cursor-pointer shadow-sm"
                  >
                    <ArrowLeft className="h-4 w-4 text-slate-600" />
                    <span>Back to Templates</span>
                  </button>
                  <div>
                    <h2 className="text-2xl font-bold text-slate-900">Variables & Custom Form Fields</h2>
                    <p className="text-sm text-slate-500">Map system-generated tokens for Merchant, Staff, Driver, Order, and Invoice templates to conditional print headers and custom forms</p>
                  </div>
                </div>

                {/* Search and Category Filter Bar */}
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                  <div className="relative w-full sm:w-64">
                    <IconSearch className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
                    <Input
                      placeholder="Search variables or keys..."
                      value={varSearchQuery}
                      onChange={(e) => setVarSearchQuery(e.target.value)}
                      className="pl-9 bg-white border-slate-200 h-9 text-xs shadow-sm"
                    />
                    {varSearchQuery && (
                      <button onClick={() => setVarSearchQuery('')} className="absolute right-2.5 top-2.5 text-slate-400 hover:text-slate-600">
                        <IconX className="h-4 w-4" />
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Dynamic Category Filter Pills */}
              <div className="flex items-center gap-2 overflow-x-auto pb-1 border-b border-slate-200">
                <button
                  onClick={() => setSelectedVarCategoryFilter('all')}
                  className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all shrink-0 cursor-pointer ${
                    selectedVarCategoryFilter === 'all'
                      ? 'bg-[#FBD037] text-slate-950 shadow-sm'
                      : 'bg-white text-slate-600 hover:bg-slate-100 border border-slate-200'
                  }`}
                >
                  All Categories ({Object.values(variables).reduce((acc, curr) => acc + (Array.isArray(curr) ? curr.length : 0), 0)})
                </button>
                {Array.from(new Set([...categories.map(c => c.name), ...Object.keys(variables)])).map((cat) => {
                  const items = variables[cat] || [];
                  return (
                    <button
                      key={cat}
                      onClick={() => setSelectedVarCategoryFilter(cat)}
                      className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all shrink-0 cursor-pointer ${
                        selectedVarCategoryFilter === cat
                          ? 'bg-[#FBD037] text-slate-950 shadow-sm'
                          : 'bg-white text-slate-600 hover:bg-slate-100 border border-slate-200'
                      }`}
                    >
                      {cat} ({items.length})
                    </button>
                  );
                })}
              </div>

              {selectedVarCategoryFilter !== 'all' && !['Merchant', 'Staff', 'Shipment', 'Invoice'].includes(selectedVarCategoryFilter) && (
                <div className="flex items-center justify-between bg-amber-50 border border-amber-200 rounded-xl p-3 my-3 shadow-sm">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-amber-900">Custom Category: <span className="underline">{selectedVarCategoryFilter}</span></span>
                    <span className="text-[10px] bg-amber-200 text-amber-800 px-2 py-0.5 rounded font-semibold">Custom Domain</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={async () => {
                        const newName = window.prompt('Enter new name for category:', selectedVarCategoryFilter);
                        if (newName && newName.trim() && newName.trim() !== selectedVarCategoryFilter) {
                          await handleUpdateCategory(selectedVarCategoryFilter, newName.trim());
                        }
                      }}
                      className="px-2.5 py-1 text-xs font-bold bg-white border border-amber-300 text-amber-800 rounded hover:bg-amber-100 transition-colors cursor-pointer"
                    >
                      Rename Category
                    </button>
                    <button
                      onClick={async () => {
                        if (window.confirm(`Are you sure you want to delete custom category "${selectedVarCategoryFilter}" and all its variables?`)) {
                          await handleDeleteCategory(selectedVarCategoryFilter);
                        }
                      }}
                      className="px-2.5 py-1 text-xs font-bold bg-red-600 text-white rounded hover:bg-red-700 transition-colors cursor-pointer"
                    >
                      Delete Category
                    </button>
                  </div>
                </div>
              )}


              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                {/* Create Custom Variable Form */}
                <Card className="bg-white border-slate-200 shadow-md col-span-1 h-fit sticky top-6">
                  <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
                    <span className="font-bold text-slate-900">Add Token Variable</span>
                    <Badge className="bg-slate-100 text-slate-700 text-[10px] border-none">System Field</Badge>
                  </div>
                  <CardContent className="p-6">
                    <form onSubmit={handleAddVariable} className="space-y-4">
                      <div>
                        <label className="text-xs font-semibold uppercase text-slate-500">Category Group</label>
                        <select
                          className="w-full mt-1 px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-800 focus:ring-2 focus:ring-[#FBD037] focus:outline-none"
                          value={isCustomCategory ? '__custom__' : newVarCategory}
                          onChange={(e) => {
                            if (e.target.value === '__custom__') {
                              setIsCustomCategory(true);
                              setNewVarKey('');
                              setNewVarName('');
                              setNewVarVal('');
                            } else {
                              setIsCustomCategory(false);
                              setNewVarCategory(e.target.value);
                              setNewVarKey('');
                              setNewVarName('');
                              setNewVarVal('');
                            }
                          }}
                        >
                          {Array.from(new Set([...categories.map(c => c.name), ...Object.keys(variables)])).map(cat => (
                            <option key={cat} value={cat}>{cat} Fields & Variables</option>
                          ))}
                          <option value="__custom__">+ Add New Custom Category...</option>
                        </select>
                        {isCustomCategory && (
                          <div className="mt-2.5 animate-fadeIn">
                            <label className="text-[10px] font-semibold uppercase text-amber-700 block mb-1">New Category Name</label>
                            <Input
                              placeholder="e.g. Warehouse Operations"
                              value={customCategoryName}
                              onChange={(e) => setCustomCategoryName(e.target.value)}
                              className="bg-amber-50/50 border-amber-300 text-xs font-semibold"
                              autoFocus
                            />
                          </div>
                        )}
                      </div>
                      {!isCustomCategory && SYSTEM_FIELDS_BY_CATEGORY[newVarCategory] ? (
                        <div>
                          <label className="text-xs font-semibold uppercase text-slate-500">Predefined System Field</label>
                          <select
                            className="w-full mt-1 px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-800 focus:ring-2 focus:ring-[#FBD037] focus:outline-none"
                            value={newVarKey}
                            onChange={(e) => {
                              const selectedKey = e.target.value;
                              const matched = SYSTEM_FIELDS_BY_CATEGORY[newVarCategory].find(f => f.key === selectedKey);
                              if (matched) {
                                setNewVarKey(matched.key);
                                setNewVarName(matched.label);
                                setNewVarVal(matched.defaultValue);
                              } else {
                                setNewVarKey('');
                                setNewVarName('');
                                setNewVarVal('');
                              }
                            }}
                          >
                            <option value="">-- Select Predefined Field --</option>
                            {(() => {
                              const existingKeys = new Set((variables[newVarCategory] || []).map(v => v.key));
                              return SYSTEM_FIELDS_BY_CATEGORY[newVarCategory]
                                .filter(field => !existingKeys.has(field.key))
                                .map(field => (
                                  <option key={field.key} value={field.key}>
                                    {field.key} ({field.label.split('(')[0].trim()})
                                  </option>
                                ));
                            })()}
                          </select>
                        </div>
                      ) : null}

                      <div>
                        <label className="text-xs font-semibold uppercase text-slate-500">Variable Display Name</label>
                        <Input
                          placeholder="e.g. Merchant Store ID"
                          value={newVarName}
                          onChange={(e) => {
                            setNewVarName(e.target.value);
                            if (!newVarKey && e.target.value) {
                              setNewVarKey(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '_'));
                            }
                          }}
                          className="mt-1"
                        />
                      </div>
                      <div>
                        <label className="text-xs font-semibold uppercase text-slate-500">System Dynamic Key</label>
                        <Input
                          placeholder="e.g. merchant_store_id"
                          value={newVarKey}
                          onChange={(e) => setNewVarKey(e.target.value)}
                          className="mt-1 font-mono text-xs"
                        />
                      </div>
                      <div>
                        <label className="text-xs font-semibold uppercase text-slate-500">Fallback / Simulator Value</label>
                        <Input
                          placeholder="e.g. MCH-9982-DXB"
                          value={newVarVal}
                          onChange={(e) => setNewVarVal(e.target.value)}
                          className="mt-1"
                        />
                      </div>
                      <Button type="submit" className="w-full bg-[#FBD037] hover:bg-yellow-400 text-slate-950 font-bold shadow-sm">
                        <Plus className="mr-2 h-4 w-4" /> Save Token Variable
                      </Button>
                    </form>
                  </CardContent>
                </Card>

                {/* Display Current System Categorized Variables */}
                <div className="col-span-1 md:col-span-2 space-y-6">
                  {Array.from(new Set([...categories.map(c => c.name), ...Object.keys(variables)]))
                    .map(cat => [cat, variables[cat] || []])
                    .filter(([category]) => selectedVarCategoryFilter === 'all' || selectedVarCategoryFilter === category)
                    .map(([category, items]: [any, any]) => {
                      const filteredItems = items.filter(v =>
                        (v.label && v.label.toLowerCase().includes(varSearchQuery.toLowerCase())) ||
                        (v.key && v.key.toLowerCase().includes(varSearchQuery.toLowerCase())) ||
                        (v.value && v.value.toString().toLowerCase().includes(varSearchQuery.toLowerCase()))
                      );
                      if (filteredItems.length === 0 && selectedVarCategoryFilter === 'all') return null;
                      const isDefaultCat = ['Merchant', 'Staff', 'Shipment', 'Invoice'].includes(category);
                      return (
                        <Card key={category} className="bg-white border-slate-200 shadow-sm">
                          <div className="px-6 py-3.5 bg-slate-50/80 border-b border-slate-100 flex justify-between items-center">
                            <div className="flex items-center gap-2 flex-wrap">
                              <span className="font-bold text-slate-900 text-sm tracking-wide capitalize">{category} Variables</span>
                              <Badge className="bg-[#FFF8D6] text-[#6E5700] border-none text-[11px] font-bold px-2 py-0.5">{filteredItems.length} Registered</Badge>
                              {!isDefaultCat && (
                                <Badge className="bg-amber-100 text-amber-800 border-none text-[10px] font-semibold px-2 py-0.5">Custom Category</Badge>
                              )}
                            </div>
                            <div className="flex items-center gap-2">
                              {!isDefaultCat && (
                                <div className="flex items-center gap-1.5">
                                  <button
                                    onClick={async () => {
                                      const newName = window.prompt('Enter new name for category:', category);
                                      if (newName && newName.trim() && newName.trim() !== category) {
                                        await handleUpdateCategory(category, newName.trim());
                                      }
                                    }}
                                    className="px-2 py-1 text-[11px] font-bold bg-white border border-slate-300 text-slate-700 rounded hover:bg-slate-100 transition-colors cursor-pointer shadow-sm"
                                  >
                                    Rename
                                  </button>
                                  <button
                                    onClick={async () => {
                                      if (window.confirm(`Are you sure you want to delete custom category "${category}" and all its variables?`)) {
                                        await handleDeleteCategory(category);
                                      }
                                    }}
                                    className="px-2 py-1 text-[11px] font-bold bg-red-600 text-white rounded hover:bg-red-700 transition-colors cursor-pointer shadow-sm"
                                  >
                                    Delete
                                  </button>
                                </div>
                              )}
                              <span className="text-[11px] text-slate-400 font-medium hidden sm:inline">Click Copy button to grab token syntax</span>
                            </div>
                          </div>
                          <CardContent className="p-4">
                            {filteredItems.length === 0 ? (
                              <div className="text-center py-8 text-slate-400 text-xs font-medium">
                                No variables registered in this category yet. Use the form on the left to add token variables!
                              </div>
                            ) : (
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                {filteredItems.map(v => (
                                  <div key={v.key} className="flex items-center justify-between p-3 bg-slate-50/70 hover:bg-slate-100/80 rounded-xl border border-slate-200/80 text-xs transition-all duration-150 group">
                                    <div className="min-w-0 pr-2">
                                      <span className="font-bold text-slate-800 block truncate mb-0.5">{v.label}</span>
                                      <div className="flex items-center gap-1.5">
                                        <code className="text-[#7A6100] bg-[#FFF8D6] px-1.5 py-0.5 rounded text-[10px] font-mono select-all font-semibold">{"{{" + v.key + "}}"}</code>
                                      </div>
                                    </div>
                                    <div className="text-right flex items-center gap-1.5 shrink-0">
                                      <span className="text-slate-500 font-mono text-[10px] block truncate max-w-[95px] bg-white px-2 py-1 rounded border border-slate-200/60" title={v.value}>{v.value}</span>
                                      <Button
                                        size="icon"
                                        variant="ghost"
                                        title="Copy token syntax"
                                        className="h-7 w-7 text-slate-600 hover:text-slate-950 hover:bg-slate-200/70 cursor-pointer"
                                        onClick={() => handleCopyToken(v.key)}
                                      >
                                        {copiedVarKey === v.key ? <Check className="h-3.5 w-3.5 text-emerald-600" /> : <Copy className="h-3.5 w-3.5" />}
                                      </Button>
                                      <Button
                                        size="icon"
                                        variant="ghost"
                                        title="Delete custom token"
                                        className="h-7 w-7 text-rose-500 hover:text-rose-700 hover:bg-rose-50 opacity-60 group-hover:opacity-100 transition-opacity cursor-pointer"
                                        onClick={async () => {
                                          try {
                                            await fetch5(`/api/document-designer/variables/${v.key}`, 'delete');
                                          } catch (err) {
                                            console.warn('API error, deleting variable locally:', err);
                                          }
                                          setVariables(prev => ({
                                            ...prev,
                                            [category]: prev[category].filter(it => it.key !== v.key)
                                          }));
                                          triggerNotification(`Removed token {{${v.key}}}.`, 'error');
                                        }}
                                      >
                                        <Trash2 className="h-3.5 w-3.5" />
                                      </Button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </CardContent>
                        </Card>
                      );
                    })}
                </div>

              </div>
            </div>
          )}

          {/* VIEW 4: DRAG AND DROP TEMPLATE DESIGNER */}
          {activeTab === 'designer' && (
            <div className="flex-1 flex min-w-0 min-h-0 overflow-hidden">

              {/* Left Toolbox Panel: Categories, Variables, Logos */}
              <aside className="w-64 2xl:w-72 bg-white border-r border-slate-200 flex flex-col shrink-0 overflow-y-auto">

                {/* Back to Templates Button */}
                <div className="p-3 border-b border-slate-100 bg-slate-50/70">
                  <button
                    onClick={() => setActiveTab('templates')}
                    className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-bold text-slate-700 hover:text-slate-950 hover:bg-slate-200/60 bg-white border border-slate-200 transition-all duration-150 cursor-pointer w-full shadow-sm"
                  >
                    <ArrowLeft className="h-4 w-4 text-slate-600" />
                    <span>Back to Templates</span>
                  </button>
                </div>

                {selectedTemplate?.isDefault && (
                  <div className="m-3 p-3 bg-amber-50 border border-amber-200 rounded-lg flex flex-col gap-1.5">
                    <div className="flex items-center gap-1.5 text-xs font-bold text-amber-800">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                      Read-Only Mode
                    </div>
                    <p className="text-[10px] text-amber-700 leading-normal font-medium">
                      This is a default system template. You cannot edit, delete, or add elements. Click <strong>Duplicate & Customize</strong> on the top bar to create your own editable copy.
                    </p>
                  </div>
                )}

                {/* Global Document Setup */}
                <div className="p-4 border-b border-slate-100 space-y-4">
                  <div>
                    <label className="text-xs font-bold uppercase tracking-wider text-slate-500 block">Template Name</label>
                    <input
                      type="text"
                      value={templateName}
                      onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter template name..."
                      disabled={selectedTemplate?.isDefault}
                      className="mt-1 w-full px-2.5 py-1.5 text-sm font-semibold text-slate-900 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400 transition-all disabled:opacity-75 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <label className="text-[10px] font-semibold text-slate-500 uppercase">Page Size</label>
                      <select
                        className="w-full mt-1 p-2 bg-slate-50 rounded border text-xs font-medium disabled:opacity-75 disabled:cursor-not-allowed"
                        value={pageSize}
                        disabled={selectedTemplate?.isDefault}
                        onChange={(e) => setPageSize(e.target.value)}
                      >
                        <option value="A4">A4 Portrait (210×297mm)</option>
                        <option value="Letter">US Letter (8.5×11")</option>
                        <option value="4x6">4×6 Shipping Label (100×150mm)</option>
                        <option value="Thermal">Thermal Roll (80mm)</option>
                      </select>
                    </div>
                    <div>
                      <label className="text-[10px] font-semibold text-slate-500 uppercase">Language Layout</label>
                      <select
                        className="w-full mt-1 p-2 bg-slate-50 rounded border text-xs font-medium disabled:opacity-75 disabled:cursor-not-allowed"
                        value={docLanguage}
                        disabled={selectedTemplate?.isDefault}
                        onChange={(e) => setDocLanguage(e.target.value)}
                      >
                        <option value="english">English (LTR)</option>
                        <option value="arabic">Arabic (RTL)</option>
                        <option value="bilingual">Bilingual (Mixed)</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Add Layout Elements Accordion */}
                <div className="p-4 border-b border-slate-100">
                  <span className="text-xs font-bold uppercase tracking-wider text-slate-500 block mb-3">Add Core Elements</span>
                  <div className="grid grid-cols-2 gap-2">
                    <Button variant="outline" size="sm" className="justify-start text-xs" onClick={() => addElementToCanvas('text')}>
                      <Type className="h-3.5 w-3.5 mr-1.5 text-amber-600" /> Static Text
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start text-xs" onClick={() => addElementToCanvas('branding')}>
                      <ImageIcon className="h-3.5 w-3.5 mr-1.5 text-violet-500" /> Logo Header
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start text-xs" onClick={() => addElementToCanvas('table')}>
                      <TableIcon className="h-3.5 w-3.5 mr-1.5 text-teal-500" /> Pricing Table
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start text-xs" onClick={() => addElementToCanvas('barcode')}>
                      <BarcodeIcon className="h-3.5 w-3.5 mr-1.5 text-orange-500" /> Barcode/QR
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start text-xs col-span-2" onClick={() => setActiveTab('branding')}>
                      <Upload className="h-3.5 w-3.5 mr-1.5 text-violet-500" /> Upload / Manage Logos
                    </Button>
                    <Button variant="outline" size="sm" className="justify-start text-xs col-span-2" onClick={() => addElementToCanvas('signature')}>
                      <Signature className="h-3.5 w-3.5 mr-1.5 text-emerald-500" /> Digital Sign Box
                    </Button>
                  </div>
                </div>

                {/* Draggable/Clickable Token Panel */}
                <div className="p-4 flex-1 flex flex-col min-h-0">
                  <span className="text-xs font-bold uppercase tracking-wider text-slate-500 block mb-1">Variables Token Panel</span>
                  <p className="text-[10px] text-slate-400 mb-3">Click on any dynamic token to place it instantly on the canvas:</p>

                  <div className="mb-3">
                    <div className="relative">
                      <IconSearch className="absolute left-2.5 top-2 h-3.5 w-3.5 text-slate-400" />
                      <Input
                        placeholder="Search tokens (e.g. merchant, driver...)"
                        value={tokenSearchQuery}
                        onChange={(e) => setTokenSearchQuery(e.target.value)}
                        className="pl-8 h-8 text-xs bg-slate-50 border-slate-200 font-medium"
                      />
                      {tokenSearchQuery && (
                        <button onClick={() => setTokenSearchQuery('')} className="absolute right-2 top-2 text-slate-400 hover:text-slate-600">
                          <IconX className="h-3.5 w-3.5" />
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="space-y-4 overflow-y-auto pr-1 flex-1">
                    {Object.entries(variables).map(([category, items]) => {
                      const filteredItems = items.filter(v =>
                        v.label.toLowerCase().includes(tokenSearchQuery.toLowerCase()) ||
                        v.key.toLowerCase().includes(tokenSearchQuery.toLowerCase()) ||
                        category.toLowerCase().includes(tokenSearchQuery.toLowerCase())
                      );
                      if (filteredItems.length === 0) return null;
                      return (
                        <div key={category} className="space-y-1.5">
                          <div className="flex items-center justify-between bg-slate-100/80 px-2 py-1 rounded">
                            <span className="text-[10px] font-extrabold uppercase text-slate-700 tracking-wide block">{category} Tokens</span>
                            <span className="text-[9px] font-bold text-slate-400">{filteredItems.length}</span>
                          </div>
                          <div className="space-y-1 pl-0.5">
                            {filteredItems.map(v => (
                              <div
                                key={v.key}
                                className="p-2 bg-slate-50 hover:bg-[#FFF8D6] hover:border-yellow-400 rounded border border-slate-100 text-xs flex justify-between items-center cursor-pointer transition-colors group"
                                onClick={() => addElementToCanvas('variable', {
                                  category,
                                  key: v.key,
                                  content: v.value,
                                  label: v.label,
                                  prefix: `${v.label}: `,
                                  prefixAr: `${v.label} (عربي): `
                                })}
                              >
                                <div className="truncate pr-1">
                                  <span className="font-semibold text-slate-700 group-hover:text-slate-950 block text-[11px] truncate">{v.label}</span>
                                  <code className="text-[#7A6100] text-[10px] font-mono">{"{{" + v.key + "}}"}</code>
                                </div>
                                <div className="shrink-0 flex items-center gap-1">
                                  <span className="text-[9px] text-slate-400 bg-white px-1 py-0.5 rounded border border-slate-200/50 hidden group-hover:inline max-w-[55px] truncate">{v.value}</span>
                                  <Plus className="h-3.5 w-3.5 text-slate-400 group-hover:text-yellow-600" />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

              </aside>

              {/* Central Design Canvas Container */}
              <main className="flex-1 min-w-0 bg-slate-100 flex flex-col overflow-hidden relative">

                {/* Canvas Zoom & Status Header */}
                <div className="bg-white border-b border-slate-200 px-4 py-2.5 flex flex-wrap items-center justify-between gap-2 z-10">
                  <div className="flex items-center gap-3">
                    <span className="hidden 2xl:inline text-xs font-medium text-slate-500">Page layout representing standard output scale.</span>
                    <div className="flex items-center border rounded-lg bg-slate-50">
                      <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => setZoom(Math.max(50, zoom - 10))}><ZoomOut className="h-4 w-4" /></Button>
                      <span className="text-xs font-semibold px-2">{zoom}%</span>
                      <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => setZoom(Math.min(150, zoom + 10))}><ZoomIn className="h-4 w-4" /></Button>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <Button variant="outline" className="text-slate-700" onClick={() => {
                      setIsPreviewOpen(true);
                      triggerNotification('Loaded live data variables preview simulation.');
                    }}>
                      <Eye className="mr-1.5 h-4 w-4" /> Live Preview & Generate
                    </Button>
                    {selectedTemplate?.isDefault ? (
                      <Button
                        className="bg-amber-600 hover:bg-amber-700 text-white flex items-center gap-1.5"
                        onClick={async () => {
                          await handleDuplicateTemplate(selectedTemplate);
                          setActiveTab('templates');
                        }}
                      >
                        <Copy className="h-4 w-4" /> Duplicate & Customize
                      </Button>
                    ) : (
                      <Button className="bg-emerald-600 hover:bg-emerald-700" onClick={async () => {
                        try {
                          if (selectedTemplate && selectedTemplate.id) {
                            // Determine orientation from page size
                            const orientationVal = pageSize === '4x6' || pageSize === 'Thermal' ? 'portrait' : 'portrait';
                            // Determine margin from page size
                            const marginVal = pageSize === 'Thermal' ? 15 : pageSize === '4x6' ? 20 : 40;

                            // Auto-extract the variable keys actually used on this canvas
                            const usedVars: string[] = [];
                            const seenKeys = new Set<string>();
                            for (const el of canvasElements) {
                              const isTracked =
                                el.type === 'variable' ||
                                el.type === 'barcode'  ||
                                el.type === 'qrcode'   ||
                                el.type === 'signature';
                              if (isTracked) {
                                // Primary: `key` field (correct convention for all element types)
                                const k = el.key
                                  ?? (typeof el.content === 'string' && /^[a-z][a-z0-9_]*$/.test(el.content) ? el.content : null);
                                if (k && !seenKeys.has(k)) { seenKeys.add(k); usedVars.push(k); }
                              }
                            }

                            // Save ALL fields at the top level so the DB stores everything correctly
                            const savePayload = {
                              name:          templateName || selectedTemplate.name,
                              type:          templateType || selectedTemplate.type,
                              orientation:   orientationVal,
                              margin:        marginVal,
                              dimensions:    { width: canvasWidth, height: canvasHeight },
                              elements:      canvasElements,       // ← full JSONB array, top-level
                              status:        templateStatus || selectedTemplate.status || 'active',
                              language:      docLanguage || 'bilingual',
                              usedVariables: usedVars,
                            };

                            await fetch5(`/api/document-designer/templates/${selectedTemplate.id}`, 'put', savePayload);

                            // Refresh template list from server
                            const res = await fetch3('/api/document-designer/templates', 'get');
                            if (res?.success && Array.isArray(res.data)) {
                              setTemplates(res.data);
                              // Keep selectedTemplate in sync with server data
                              const updated = res.data.find((t: any) => t.id === selectedTemplate.id);
                              if (updated) setSelectedTemplate(updated);
                            }
                            triggerNotification('Document template saved successfully — all elements & variables persisted.');
                          } else {
                            triggerNotification('No template selected — please select or create a template first.', 'error');
                          }
                        } catch (err: any) {
                          console.error('Save error:', err);
                          const msg = err?.message || 'Failed to save template.';
                          triggerNotification(msg, 'error');
                        }
                      }}>
                        <Save className="mr-1.5 h-4 w-4" /> Save Changes
                      </Button>
                    )}
                  </div>
                </div>

                {/* Dynamic Workspace Container */}
                <div className="flex-1 overflow-auto p-4 lg:p-6 flex justify-center items-start bg-slate-100/60">

                  {/* Template Canvas Page Wrapper (for clean zoom scaling without flex layout shifts) */}
                  <div
                    className="transition-all duration-150 shrink-0 flex justify-center"
                    style={{
                      width: `${canvasWidth * (zoom / 100)}px`,
                      height: `${canvasHeight * (zoom / 100)}px`,
                    }}
                  >
                    {/* Template Canvas Page */}
                    <div
                      className="bg-white shadow-2xl relative border border-slate-300 rounded-sm transition-all origin-top-left"
                      style={{
                        width: `${canvasWidth}px`,
                        height: `${canvasHeight}px`,
                        transform: `scale(${zoom / 100})`,
                        backgroundImage: 'radial-gradient(#cbd5e1 1px, transparent 1px)',
                        backgroundSize: '16px 16px'
                      }}
                    >

                      {/* Watermark simulation */}
                      <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] select-none pointer-events-none">
                        <span className="text-7xl font-bold uppercase tracking-widest text-slate-900 rotate-45">APEX OFFICIAL</span>
                      </div>

                      {/* Interactive Canvas Element Placements */}
                      {canvasElements.map(el => {
                        const isSelected = selectedElementId === el.id;

                        return (
                          <div
                            key={el.id}
                            className={`absolute group p-1.5 rounded transition-all cursor-pointer ${isSelected
                              ? 'border-2 border-[#FBD037] bg-[#FFF8D6]/20 shadow-md ring-2 ring-yellow-400/10'
                              : 'border border-transparent hover:border-slate-300 hover:bg-slate-50/40'
                              }`}
                            style={{
                              left: `${el.x}px`,
                              top: `${el.y}px`,
                              width: el.width ? `${el.width}px` : 'auto',
                              height: el.height ? `${el.height}px` : 'auto',
                              border: el.border || undefined,
                              background: el.background || undefined,
                              padding: el.padding || undefined,
                              boxSizing: 'border-box',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: el.justifyContent || 'center'
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedElementId(el.id);
                            }}
                          >

                            {/* Element Actions Bar when hovered/selected */}
                            {!selectedTemplate?.isDefault && (
                              <div className={`absolute -top-7 right-0 flex items-center gap-1.5 bg-slate-900 text-white rounded px-1.5 py-0.5 shadow z-30 transition-opacity ${isSelected ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
                                }`}>
                                <span className="text-[10px] uppercase font-bold text-slate-300">{el.type}</span>
                                <div className="h-3 w-px bg-slate-700 mx-1"></div>

                                {/* Fast positioning D-Pad */}
                                <button className="hover:text-[#FBD037]" onClick={(e) => { e.stopPropagation(); handleMoveElement(el.id, 'up'); }} title="Move Up">↑</button>
                                <button className="hover:text-[#FBD037]" onClick={(e) => { e.stopPropagation(); handleMoveElement(el.id, 'down'); }} title="Move Down">↓</button>
                                <button className="hover:text-[#FBD037]" onClick={(e) => { e.stopPropagation(); handleMoveElement(el.id, 'left'); }} title="Move Left">←</button>
                                <button className="hover:text-[#FBD037]" onClick={(e) => { e.stopPropagation(); handleMoveElement(el.id, 'right'); }} title="Move Right">→</button>

                                <button
                                  className="text-rose-400 hover:text-rose-600 ml-1"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setCanvasElements(prev => prev.filter(item => item.id !== el.id));
                                    setSelectedElementId(null);
                                    triggerNotification('Element removed from canvas.', 'error');
                                  }}
                                >
                                  <Trash2 className="h-3 w-3" />
                                </button>
                              </div>
                            )}

                            {/* Render Specific Element Types */}
                            {el.type === 'branding' && (
                              <div className="w-full h-full flex items-center justify-start">
                                <img
                                  src={logos.find(l => l.id === el.content)?.url || el.content || logos[0]?.url}
                                  className="max-h-full max-w-full object-contain"
                                  alt="Branding"
                                />
                              </div>
                            )}

                            {el.type === 'text' && (
                              <div
                                className={`w-full text-slate-900`}
                                style={{
                                  fontSize: `${el.fontSize || 12}px`,
                                  fontWeight: el.fontWeight || 'normal',
                                  color: el.color || '#000000',
                                  textAlign: el.align || 'left'
                                }}
                              >
                                {docLanguage === 'arabic' ? 'نص ثابت تجريبي للمستند' : el.content}
                              </div>
                            )}

                            {el.type === 'variable' && (
                              <div
                                className="w-full text-[#5F4B00]"
                                style={{
                                  fontSize: `${el.fontSize || 12}px`,
                                  fontWeight: el.fontWeight || 'bold',
                                  color: el.color || '#B38A00',
                                  textAlign: el.align || 'left'
                                }}
                              >
                                <span className="text-slate-400 font-normal">
                                  {docLanguage === 'arabic' ? el.prefixAr : el.prefix}
                                </span>
                                <span>{el.content}</span>
                              </div>
                            )}

                            {el.type === 'barcode' && (
                              <div className="w-full h-full flex flex-col items-center justify-center bg-white p-1">
                                <RealBarcode value={el.content || '123456789'} height={Math.max(20, (el.height || 40) - 20)} width={1.5} displayValue={false} />
                                <span className="text-[10px] font-mono mt-1 text-slate-500">{el.content}</span>
                              </div>
                            )}

                            {el.type === 'qrcode' && (
                              <div className="w-full h-full flex flex-col items-center justify-center bg-white p-1">
                                <img
                                  src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(el.content || '12345')}`}
                                  className="max-h-full max-w-full object-contain"
                                  alt="QR Code"
                                />
                              </div>
                            )}

                            {el.type === 'signature' && (
                              <div className="w-full h-full flex flex-col justify-between bg-slate-50/50 border border-dashed border-slate-300 p-2 rounded">
                                <span className="text-[9px] uppercase tracking-wider text-slate-400">Digital Placeholder Signature</span>
                                <div className="h-10 flex items-center justify-center text-slate-300 font-serif italic text-lg select-none">
                                  Signee Signature Verified
                                </div>
                                <span className="text-[10px] font-medium text-center text-slate-600">{el.content}</span>
                              </div>
                            )}

                            {el.type === 'table' && (
                              <div className="w-full overflow-hidden border border-slate-200 rounded text-[11px] bg-white">
                                <table className="w-full text-left">
                                  <thead className="bg-slate-100 text-[10px] uppercase font-bold text-slate-600">
                                    <tr>
                                      <th className="p-1 px-2">Code</th>
                                      <th className="p-1 px-2">Service Line / الوصف</th>
                                      <th className="p-1 px-2 text-right">Qty</th>
                                      <th className="p-1 px-2 text-right">Rate</th>
                                      <th className="p-1 px-2 text-right">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody className="divide-y divide-slate-100">
                                    {el.tableData?.map(row => (
                                      <tr key={row.id}>
                                        <td className="p-1 px-2 font-mono text-[10px]">{row.code}</td>
                                        <td className="p-1 px-2">
                                          {docLanguage === 'english' && row.descEn}
                                          {docLanguage === 'arabic' && row.descAr}
                                          {docLanguage === 'bilingual' && (
                                            <div className="flex flex-col">
                                              <span>{row.descEn}</span>
                                              <span className="text-slate-400 text-[9px] text-right">{row.descAr}</span>
                                            </div>
                                          )}
                                        </td>
                                        <td className="p-1 px-2 text-right">{row.qty}</td>
                                        <td className="p-1 px-2 text-right">AED {row.rate}</td>
                                        <td className="p-1 px-2 text-right font-semibold">AED {row.total}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}

                          </div>
                        );
                      })}

                    </div>
                  </div>

                </div>
              </main>

              {/* Right Settings Property Inspector */}
              <aside className="w-64 2xl:w-72 bg-white border-l border-slate-200 flex flex-col shrink-0 overflow-y-auto">
                {selectedElement ? (
                  <fieldset disabled={selectedTemplate?.isDefault} className="p-5 space-y-6">
                    <div>
                      <span className="text-[10px] uppercase font-extrabold text-slate-400 block tracking-wider">Element Type</span>
                      <select
                        className="w-full mt-1 p-1 px-2 border rounded text-xs h-8 bg-white font-semibold text-slate-700 capitalize"
                        value={selectedElement.type}
                        onChange={(e) => updateSelectedElement('type', e.target.value)}
                      >
                        <option value="text">Static Text</option>
                        <option value="variable">Variable Token</option>
                        <option value="barcode">Barcode</option>
                        <option value="qrcode">QR Code</option>
                        <option value="branding">Brand Logo</option>
                        <option value="signature">Digital Signature</option>
                        <option value="table">Pricing Table</option>
                      </select>
                    </div>

                    {/* Standard Content Editing */}
                    {selectedElement.type === 'text' && (
                      <div className="space-y-2">
                        <label className="text-xs font-semibold text-slate-600">Text Content / Static String</label>
                        <textarea
                          className="w-full p-2 border rounded text-xs bg-slate-50 font-medium"
                          rows={3}
                          value={selectedElement.content}
                          onChange={(e) => updateSelectedElement('content', e.target.value)}
                        />
                      </div>
                    )}

                    {selectedElement.type === 'variable' && (
                      <div className="space-y-4">
                        <div className="space-y-1.5">
                          <label className="text-xs font-semibold text-slate-600">English Prefix Label</label>
                          <Input
                            value={selectedElement.prefix || ''}
                            onChange={(e) => updateSelectedElement('prefix', e.target.value)}
                            className="text-xs h-8"
                          />
                        </div>
                        <div className="space-y-1.5">
                          <label className="text-xs font-semibold text-slate-600">Arabic Prefix Label (RTL)</label>
                          <Input
                            value={selectedElement.prefixAr || ''}
                            onChange={(e) => updateSelectedElement('prefixAr', e.target.value)}
                            className="text-xs h-8"
                            dir="rtl"
                          />
                        </div>
                      </div>
                    )}

                    {(selectedElement.type === 'variable' || selectedElement.type === 'barcode' || selectedElement.type === 'qrcode') && (
                      <div className="space-y-1.5">
                        <label className="text-xs font-semibold text-slate-600">Dynamic Variable Token Binding</label>
                        <select
                          className="w-full mt-1 p-2 bg-slate-50 rounded border text-xs font-medium font-mono"
                          value={selectedElement.key || ''}
                          onChange={(e) => {
                            const selectedKey = e.target.value;
                            // Find the corresponding variable to update content default
                            let defaultValue = '';
                            for (const [cat, items] of Object.entries(variables)) {
                              const found = (items as any[]).find(v => v.key === selectedKey);
                              if (found) {
                                defaultValue = found.value || '';
                                break;
                              }
                            }
                            // Update both key and content (default)
                            setCanvasElements(prev => prev.map(el => {
                              if (el.id !== selectedElementId) return el;
                              return { ...el, key: selectedKey, content: defaultValue };
                            }));
                          }}
                        >
                          <option value="">-- Select Token to Bind --</option>
                          {Object.entries(variables).map(([category, items]) => (
                            <optgroup key={category} label={`${category} Tokens`}>
                              {(items as any[]).map(v => (
                                <option key={v.key} value={v.key}>{v.label} ({v.key})</option>
                              ))}
                            </optgroup>
                          ))}
                        </select>
                      </div>
                    )}

                    {selectedElement.type === 'branding' && (
                      <div className="space-y-4">
                        <div className="space-y-1.5">
                          <label className="text-xs font-semibold text-slate-600">Assigned Entity Brand Logo</label>
                          <select
                            className="w-full mt-1 p-2 bg-slate-50 rounded border text-xs font-medium"
                            value={selectedElement.content}
                            onChange={(e) => updateSelectedElement('content', e.target.value)}
                          >
                            <option value="">-- Or Upload Custom Image below --</option>
                            {logos.map(l => (
                              <option key={l.id} value={l.id}>{l.name}</option>
                            ))}
                          </select>
                        </div>
                        <div className="space-y-1.5">
                          <label className="text-xs font-semibold text-slate-600">Upload Custom Image (Base64)</label>
                          <Input
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) {
                                const reader = new FileReader();
                                reader.onload = (event) => {
                                  if (event.target?.result) {
                                    updateSelectedElement('content', event.target.result as string);
                                    triggerNotification('Custom image uploaded to element.');
                                  }
                                };
                                reader.readAsDataURL(file);
                              }
                            }}
                            className="text-xs cursor-pointer border-dashed border-2 py-1 flex items-center justify-center"
                          />
                        </div>
                      </div>
                    )}

                    {/* Text Styling (Fonts, Weight, Color) */}
                    {(selectedElement.type === 'text' || selectedElement.type === 'variable') && (
                      <div className="space-y-4 border-t pt-4">
                        <span className="text-xs font-bold uppercase tracking-wider text-slate-500 block">Typography</span>

                        <div className="grid grid-cols-2 gap-2">
                          <div>
                            <label className="text-[10px] font-semibold text-slate-400 uppercase">Font Size</label>
                            <Input
                              type="number"
                              value={selectedElement.fontSize || 12}
                              onChange={(e) => updateSelectedElement('fontSize', parseInt(e.target.value))}
                              className="text-xs h-8 mt-1"
                            />
                          </div>
                          <div>
                            <label className="text-[10px] font-semibold text-slate-400 uppercase">Alignment</label>
                            <select
                              className="w-full mt-1 p-1 px-2 border rounded text-xs h-8 bg-white"
                              value={selectedElement.align || 'left'}
                              onChange={(e) => updateSelectedElement('align', e.target.value)}
                            >
                              <option value="left">Left (LTR)</option>
                              <option value="center">Center</option>
                              <option value="right">Right (RTL)</option>
                            </select>
                          </div>
                        </div>

                        <div className="flex gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            className={`flex-1 text-xs ${selectedElement.fontWeight === 'bold' ? 'bg-slate-200' : ''}`}
                            onClick={() => updateSelectedElement('fontWeight', selectedElement.fontWeight === 'bold' ? 'normal' : 'bold')}
                          >
                            Bold
                          </Button>
                          <Button
                            variant="outline"
                            size="sm"
                            className={`flex-1 text-xs ${selectedElement.fontStyle === 'italic' ? 'bg-slate-200' : ''}`}
                            onClick={() => updateSelectedElement('fontStyle', selectedElement.fontStyle === 'italic' ? 'normal' : 'italic')}
                          >
                            Italic
                          </Button>
                        </div>

                        <div>
                          <label className="text-[10px] font-semibold text-slate-400 uppercase">Text Hex Color</label>
                          <div className="flex items-center gap-2 mt-1">
                            <input
                              type="color"
                              value={selectedElement.color || '#000000'}
                              onChange={(e) => updateSelectedElement('color', e.target.value)}
                              className="w-8 h-8 rounded cursor-pointer"
                            />
                            <Input
                              value={selectedElement.color || '#000000'}
                              onChange={(e) => updateSelectedElement('color', e.target.value)}
                              className="text-xs h-8"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Canvas Absolute Position Controls */}
                    <div className="space-y-4 border-t pt-4">
                      <span className="text-xs font-bold uppercase tracking-wider text-slate-500 block">Position on Page</span>
                      <div className="grid grid-cols-2 gap-2">
                        <div>
                          <label className="text-[10px] font-semibold text-slate-400 uppercase">X Coordinate (px)</label>
                          <Input
                            type="number"
                            value={selectedElement.x}
                            onChange={(e) => updateSelectedElement('x', parseInt(e.target.value) || 0)}
                            className="text-xs h-8 mt-1"
                          />
                        </div>
                        <div>
                          <label className="text-[10px] font-semibold text-slate-400 uppercase">Y Coordinate (px)</label>
                          <Input
                            type="number"
                            value={selectedElement.y}
                            onChange={(e) => updateSelectedElement('y', parseInt(e.target.value) || 0)}
                            className="text-xs h-8 mt-1"
                          />
                        </div>
                        <div>
                          <label className="text-[10px] font-semibold text-slate-400 uppercase">Width (px)</label>
                          <Input
                            type="number"
                            value={selectedElement.width || 100}
                            onChange={(e) => updateSelectedElement('width', parseInt(e.target.value) || 100)}
                            className="text-xs h-8 mt-1"
                          />
                        </div>
                        <div>
                          <label className="text-[10px] font-semibold text-slate-400 uppercase">Height (px)</label>
                          <Input
                            type="number"
                            value={selectedElement.height || 40}
                            onChange={(e) => updateSelectedElement('height', parseInt(e.target.value) || 40)}
                            className="text-xs h-8 mt-1"
                          />
                        </div>
                      </div>

                      {/* Quick Alignment Helpers */}
                      <div className="pt-3 border-t border-slate-100">
                        <label className="text-[10px] font-semibold text-slate-400 uppercase block mb-1.5">Quick Alignment & Width</label>
                        <div className="grid grid-cols-2 gap-1.5">
                          <Button
                            size="sm"
                            variant="outline"
                            className="text-[11px] h-7 bg-slate-50 hover:bg-[#FFF8D6] hover:border-yellow-400 text-slate-700"
                            onClick={() => {
                              const margin = pageSize === 'Thermal' ? 15 : pageSize === '4x6' ? 20 : 40;
                              updateSelectedElement('width', canvasWidth - (margin * 2));
                              updateSelectedElement('x', margin);
                              triggerNotification('Element width aligned perfectly to page margins.');
                            }}
                          >
                            Fit Page Width
                          </Button>
                          <Button
                            size="sm"
                            variant="outline"
                            className="text-[11px] h-7 bg-slate-50 hover:bg-[#FFF8D6] hover:border-yellow-400 text-slate-700"
                            onClick={() => {
                              const w = selectedElement.width || 100;
                              updateSelectedElement('x', Math.max(0, Math.round((canvasWidth - w) / 2)));
                              triggerNotification('Element centered horizontally.');
                            }}
                          >
                            Center Horizontally
                          </Button>
                      </div>
                    </div>
                  </div>

                    {/* Border & Styling */}
                    <div className="space-y-4 border-t pt-4">
                      <span className="text-xs font-bold uppercase tracking-wider text-slate-500 block">Border & Styling</span>
                      <div className="space-y-3">
                        <div>
                          <label className="text-[10px] font-semibold text-slate-400 uppercase">Border CSS</label>
                          <Input
                            placeholder="e.g. 1px solid #000"
                            value={selectedElement.border || ''}
                            onChange={(e) => updateSelectedElement('border', e.target.value)}
                            className="text-xs h-8 mt-1"
                          />
                        </div>
                        <div>
                          <label className="text-[10px] font-semibold text-slate-400 uppercase">Background CSS</label>
                          <Input
                            placeholder="e.g. #f8fafc"
                            value={selectedElement.background || ''}
                            onChange={(e) => updateSelectedElement('background', e.target.value)}
                            className="text-xs h-8 mt-1"
                          />
                        </div>
                        <div>
                          <label className="text-[10px] font-semibold text-slate-400 uppercase">Padding CSS</label>
                          <Input
                            placeholder="e.g. 4px"
                            value={selectedElement.padding || ''}
                            onChange={(e) => updateSelectedElement('padding', e.target.value)}
                            className="text-xs h-8 mt-1"
                          />
                        </div>
                        <div>
                          <label className="text-[10px] font-semibold text-slate-400 uppercase">Vertical Alignment</label>
                          <select
                            className="w-full mt-1 p-1 px-2 border rounded text-xs h-8 bg-white"
                            value={selectedElement.justifyContent || 'center'}
                            onChange={(e) => updateSelectedElement('justifyContent', e.target.value)}
                          >
                            <option value="flex-start">Top</option>
                            <option value="center">Center</option>
                            <option value="flex-end">Bottom</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Advanced Logic Properties */}
                    <div className="space-y-3 border-t pt-4">
                      <span className="text-xs font-bold uppercase tracking-wider text-slate-500 block">Conditional Display Logic</span>
                      <div className="bg-slate-50 p-3 rounded-lg border text-xs">
                        <label className="text-[10px] font-semibold text-slate-500 block uppercase mb-1">Visibility Condition</label>
                        <select className="w-full p-1 bg-white border rounded text-xs mb-2">
                          <option>Always Show Element</option>
                          <option>Show only if total_amount &gt; AED 500</option>
                          <option>Show only if destination = Dubai</option>
                          <option>Hide if country is International</option>
                        </select>
                        <p className="text-[10px] text-slate-400">Dynamically evaluates system tokens to include or strip component during execution.</p>
                      </div>
                    </div>

                  </fieldset>
                ) : (
                  <div className="flex-1 flex flex-col items-center justify-center p-6 text-center text-slate-400">
                    <AlertCircle className="h-8 w-8 mb-2" />
                    <p className="text-xs font-medium">No canvas element selected.</p>
                    <p className="text-[10px] mt-1 text-slate-400">Click on any element in the workspace or add a new one from the left toolbox.</p>
                  </div>
                )}
              </aside>

            </div>
          )}

        </div>

      </div>

      {/* STYLISH LIVE PREVIEW & EXPORT SIMULATOR DIALOG */}
      {isPreviewOpen && (
        <div className="fixed inset-0 z-50 bg-slate-900/65 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl max-w-5xl w-full h-[90vh] flex flex-col shadow-2xl overflow-hidden border border-slate-200">

            {/* Modal Header bar */}
            <header className="bg-slate-900 text-white px-6 py-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Sparkles className="h-5 w-5 text-yellow-400 animate-pulse" />
                <div>
                  <h3 className="text-base font-bold">Dynamic Preview & Export Engine</h3>
                  <p className="text-xs text-slate-400">Real-time variables hydration, template rendering & multiple download formats</p>
                </div>
              </div>
              <Button
                variant="ghost"
                className="text-slate-400 hover:text-white"
                onClick={() => {
                  setIsPreviewOpen(false);
                  setIsEmailSent(false);
                }}
              >
                Close Engine
              </Button>
            </header>

            {/* Modal Split View */}
            <div className="flex-1 flex overflow-hidden">

              {/* Variable Overrides (Simulator Parameters) */}
              <div className="w-80 bg-slate-50 border-r border-slate-200 p-5 overflow-y-auto space-y-6">
                <div>
                  <h4 className="font-bold text-slate-900 text-sm">Dynamic Value Simulator</h4>
                  <p className="text-xs text-slate-400">Overwrite token values below to immediately test formatting, Arabic RTL flow, or spacing constraints:</p>
                </div>

                {Object.entries(variables).map(([category, items]) => (
                  <div key={category} className="space-y-3">
                    <span className="text-[10px] uppercase font-bold text-slate-500 tracking-wider block">{category} Overrides</span>
                    {items.map(v => (
                      <div key={v.key} className="space-y-1">
                        <label className="text-[10px] font-medium text-slate-600 block">{v.label}</label>
                        <Input
                          defaultValue={v.value}
                          onChange={(e) => {
                            const val = e.target.value;
                            setCanvasElements(prev => prev.map(el => {
                              if (el.key === v.key) {
                                return { ...el, content: val };
                              }
                              return el;
                            }));
                          }}
                          className="h-8 text-xs bg-white"
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>

              {/* Rendered Output Page (Representing finished PDF) */}
              <div className="flex-1 bg-slate-100 p-6 overflow-y-auto flex flex-col items-center gap-4">

                {/* Generation Formats Bar */}
                <div className="w-full max-w-[710px] bg-white p-3 rounded-lg border shadow-sm flex items-center justify-between text-xs font-semibold text-slate-700">
                  <div className="flex items-center gap-2">
                    <Badge className="bg-emerald-100 text-emerald-800 border-none">Active Version: {templateVersion}</Badge>
                    <Badge variant="outline" className="text-[#7A6100]">Language: {docLanguage}</Badge>
                  </div>
                  <div className="flex gap-2">
                    <Button size="sm" variant="outline" className="text-xs h-8" onClick={() => triggerNotification('Printed layout configuration sent to primary queue.')}>
                      <Printer className="h-3.5 w-3.5 mr-1" /> Direct Print
                    </Button>
                    <Button size="sm" variant="outline" className="text-xs h-8" onClick={() => triggerNotification('Exported PDF stored in cloud session successfully.')}>
                      <Download className="h-3.5 w-3.5 mr-1" /> PDF Export
                    </Button>
                    <Button size="sm" variant="outline" className="text-xs h-8" onClick={() => setIsEmailSent(true)}>
                      <Mail className="h-3.5 w-3.5 mr-1" /> Email Document
                    </Button>
                  </div>
                </div>

                {isEmailSent && (
                  <div className="w-full max-w-[710px] bg-emerald-50 border border-emerald-200 text-emerald-800 p-4 rounded-lg flex items-center justify-between text-xs">
                    <div className="flex items-center gap-2">
                      <Check className="h-4 w-4 text-emerald-600" />
                      <span>Document emailed to registered recipient: <strong>operations@alfuttaim.ae</strong></span>
                    </div>
                    <Button size="sm" variant="ghost" className="h-6 text-emerald-800 hover:bg-emerald-100" onClick={() => setIsEmailSent(false)}>Dismiss</Button>
                  </div>
                )}

                {/* Hydrated Output Frame */}
                {(() => {
                  const previewScale = Math.min(1, 710 / canvasWidth);
                  const previewWidth = Math.round(canvasWidth * previewScale);
                  const previewHeight = Math.max(600, Math.round(canvasHeight * previewScale));

                  return (
                    <div
                      className="bg-white shadow-lg relative border border-slate-300 rounded-sm p-8 mx-auto"
                      style={{
                        width: `${previewWidth}px`,
                        minHeight: `${previewHeight}px`,
                        fontFamily: 'sans-serif'
                      }}
                    >
                      {/* Watermark in output */}
                      <div className="absolute inset-0 flex items-center justify-center opacity-[0.02] select-none pointer-events-none">
                        <span className="text-6xl font-bold uppercase tracking-widest rotate-45">APEX OFFICIAL SYSTEM DOCUMENT</span>
                      </div>

                      {/* Render elements inline with actual evaluated details */}
                      {canvasElements.map(el => {
                        return (
                          <div
                            key={el.id}
                            className="absolute"
                            style={{
                              left: `${el.x * previewScale}px`,
                              top: `${el.y * previewScale}px`,
                              width: el.width ? `${el.width * previewScale}px` : 'auto',
                              height: el.height ? `${el.height * previewScale}px` : 'auto',
                              border: el.border || undefined,
                              background: el.background || undefined,
                              padding: el.padding || undefined,
                              boxSizing: 'border-box',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: el.justifyContent || 'center'
                            }}
                          >
                            {el.type === 'branding' && (
                              <img
                                src={logos.find(l => l.id === el.content)?.url || logos[0]?.url || el.content}
                                className="max-h-12 object-contain"
                                alt="Brand Logo"
                              />
                            )}

                            {el.type === 'text' && (
                              <div
                                style={{
                                  fontSize: `${el.fontSize || 12}px`,
                                  fontWeight: el.fontWeight || 'normal',
                                  color: el.color || '#000000',
                                  textAlign: el.align || 'left'
                                }}
                              >
                                {docLanguage === 'arabic' ? 'فاتورة ضريبية رسمية وموثقة من دائرة الجمارك' : el.content}
                              </div>
                            )}

                            {el.type === 'variable' && (
                              <div
                                style={{
                                  fontSize: `${el.fontSize || 12}px`,
                                  fontWeight: el.fontWeight || 'bold',
                                  color: el.color || '#B38A00',
                                  textAlign: el.align || 'left'
                                }}
                              >
                                <span className="text-slate-400 font-normal">
                                  {docLanguage === 'arabic' ? el.prefixAr : el.prefix}
                                </span>
                                <span>{el.content}</span>
                              </div>
                            )}

                            {el.type === 'barcode' && (
                              <div className="flex flex-col items-center p-1 bg-white">
                                <RealBarcode value={el.content || '123456789'} height={Math.max(15, ((el.height || 40) - 20) * previewScale)} width={1.5} displayValue={false} />
                                <span className="text-[9px] font-mono mt-0.5 text-slate-500">{el.content}</span>
                              </div>
                            )}

                            {el.type === 'qrcode' && (
                              <div className="w-full h-full flex flex-col items-center justify-center bg-white p-1">
                                <img
                                  src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(el.content || '12345')}`}
                                  className="max-h-full max-w-full object-contain"
                                  alt="QR Code"
                                />
                              </div>
                            )}

                            {el.type === 'signature' && (
                              <div className="border border-dashed border-slate-300 p-2 rounded bg-slate-50/20 text-center">
                                <div className="font-serif italic text-sm text-slate-400">Digital Seal Verified</div>
                                <span className="text-[10px] font-bold text-slate-700">{el.content}</span>
                              </div>
                            )}

                            {el.type === 'table' && (
                              <div className="w-full border border-slate-200 rounded text-[10px] bg-white mt-1">
                                <table className="w-full text-left">
                                  <thead className="bg-slate-50 text-[9px] uppercase font-bold text-slate-500">
                                    <tr>
                                      <th className="p-1 px-2">Code</th>
                                      <th className="p-1 px-2">Description / التفاصيل</th>
                                      <th className="p-1 px-2 text-right">Qty</th>
                                      <th className="p-1 px-2 text-right">Rate</th>
                                      <th className="p-1 px-2 text-right">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody className="divide-y divide-slate-100">
                                    {el.tableData?.map(row => (
                                      <tr key={row.id}>
                                        <td className="p-1 px-2 font-mono">{row.code}</td>
                                        <td className="p-1 px-2">
                                          {docLanguage === 'english' && row.descEn}
                                          {docLanguage === 'arabic' && row.descAr}
                                          {docLanguage === 'bilingual' && (
                                            <div className="flex justify-between items-center">
                                              <span>{row.descEn}</span>
                                              <span className="text-slate-400 text-[8px]" dir="rtl">{row.descAr}</span>
                                            </div>
                                          )}
                                        </td>
                                        <td className="p-1 px-2 text-right">{row.qty}</td>
                                        <td className="p-1 px-2 text-right">AED {row.rate}</td>
                                        <td className="p-1 px-2 text-right font-bold">AED {row.total}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}

                          </div>
                        );
                      })}

                    </div>
                  );
                })()}

              </div>

            </div>

          </div>
        </div>
      )}

    </div>
  );
}
